
document.addEventListener("DOMContentLoaded",function(){
  var app=document.querySelector(".ds2-app"); if(!app) return;
  function play(el,cls){ if(!el) return; el.classList.remove(cls); void el.offsetWidth; el.classList.add(cls); el.addEventListener("animationend",function h(){el.classList.remove(cls);el.removeEventListener("animationend",h);}); }
  // tabs
  document.querySelectorAll(".ds2-tab").forEach(function(t){
    t.addEventListener("click",function(){
      document.querySelectorAll(".ds2-tab").forEach(function(x){x.classList.remove("on");});
      t.classList.add("on"); play(t,"naa-press");
      var n=t.getAttribute("data-dt");
      document.querySelectorAll(".ds2-p").forEach(function(p){ p.hidden = p.getAttribute("data-dtp")!==n; });
    });
  });
  // live letter controls
  var letter=app.querySelector(".ds2-letter");
  app.addEventListener("input",function(e){
    var r=e.target; if(!r.classList.contains("ds2-rng")||!letter) return;
    var k=r.getAttribute("data-ds2");
    if(k==="size") letter.style.setProperty("--ls", r.value);
    if(k==="thick") letter.style.setProperty("--lb", r.value+"px");
    if(k==="radius") letter.style.setProperty("--lr", r.value+"px");
    if(k==="opacity") letter.style.setProperty("--lo", (r.value/100));
  });
  // delegated interactions
  app.addEventListener("click",function(e){
    var t;
    if(t=e.target.closest(".ds2-segbtn")){ t.parentNode.querySelectorAll(".ds2-segbtn").forEach(function(x){x.classList.remove("on");}); t.classList.add("on"); play(t,"naa-press"); return; }
    if(t=e.target.closest(".ds2-theme")){ t.parentNode.querySelectorAll(".ds2-theme").forEach(function(x){x.classList.remove("on");}); t.classList.add("on"); play(t,"naa-press"); return; }
    if(t=e.target.closest(".ds2-sw")){ var g=t.closest("[data-swgroup]"); if(g){ g.querySelectorAll(".ds2-sw").forEach(function(x){x.classList.remove("on");}); } t.classList.add("on"); play(t,"naa-pop"); return; }
    if(t=e.target.closest(".ds2-reimagine")){ play(t.querySelector(".icn"),"naa-spin"); play(t,"naa-press"); return; }
    if(t=e.target.closest(".ds2-toggle")){ t.classList.toggle("on"); return; }
    if(t=e.target.closest(".ds2-check")){ t.classList.toggle("on"); play(t,"naa-pop"); return; }
    if(t=e.target.closest(".ds2-reset,.ds2-btn,.ds2-ph-btn,.mrow .act")){ play(t,"naa-press"); return; }
  });
});

;

(function(){
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- springy staggered scroll-reveal ---- */
  var els = Array.prototype.slice.call(document.querySelectorAll('.sec-head, .feature > div, .fstep, .fstep2, .af, .proof, .stat, .ent-card, .quote, .roi-card, .ent .lead, .intstrip, .ds-studio'));
  els.forEach(function(el){ el.classList.add('reveal'); });
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if(e.isIntersecting){
        var sibs = e.target.parentElement ? Array.prototype.indexOf.call(e.target.parentElement.children, e.target) : 0;
        e.target.style.transitionDelay = ((sibs % 6) * 90) + 'ms';
        e.target.classList.add('in');
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
  els.forEach(function(el){ io.observe(el); });

  /* ---- hero entrance ---- */
  var hg = document.querySelector('.hero-grid');
  if(hg && !reduce){
    var copy = hg.children[0], fig = hg.children[1];
    var kids = copy ? Array.prototype.slice.call(copy.children) : [];
    kids.forEach(function(el){ el.style.opacity=0; el.style.transform='translateY(22px)'; el.style.transition='opacity .6s ease, transform .85s cubic-bezier(.34,1.22,.45,1)'; });
    if(fig){ fig.style.opacity=0; fig.style.transition='opacity .9s ease'; }
    requestAnimationFrame(function(){
      kids.forEach(function(el,i){ setTimeout(function(){ el.style.opacity=1; el.style.transform='none'; }, 100+i*95); });
      if(fig) setTimeout(function(){ fig.style.opacity=1; }, 280);
    });
  }

  /* ---- count-up ---- */
  function ac(el){
    var raw=el.getAttribute('data-count'), suf=el.getAttribute('data-suffix')||'', pre=el.getAttribute('data-prefix')||'';
    var val=parseFloat(raw), dec=(raw.split('.')[1]||'').length, t0=null;
    var dur=parseInt(el.getAttribute('data-dur')||'2900',10);
    function step(ts){ if(!t0)t0=ts; var p=Math.min((ts-t0)/dur,1); var e=1-Math.pow(1-p,3); el.textContent=pre+(val*e).toFixed(dec)+suf; if(p<1)requestAnimationFrame(step); }
    requestAnimationFrame(step);
  }
  var io2 = new IntersectionObserver(function(en){ en.forEach(function(e){ if(e.isIntersecting){ ac(e.target); io2.unobserve(e.target); } }); }, { threshold: 0.6 });
  document.querySelectorAll('[data-count]').forEach(function(el){ io2.observe(el); });

  if(reduce) return;

  /* ---- cursor spotlight ---- */
  var spot = document.createElement('div'); spot.id='spot'; document.body.appendChild(spot);
  window.addEventListener('mousemove', function(e){ spot.style.transform='translate('+e.clientX+'px,'+e.clientY+'px)'; spot.style.opacity=1; }, { passive:true });

  /* ---- letter types itself ---- */
  var letter=document.querySelector('.qs-letter');
  if(letter){
    var full=letter.textContent; letter.textContent=''; letter.style.minHeight='60px'; var i=0;
    function type(){ if(i<=full.length){ letter.textContent=full.slice(0,i); i++; setTimeout(type, 16); } }
    setTimeout(type, 1100);
  }

})();

;

/* ===== v13 additions: live pipeline · ROI bars grow ===== */
(function(){
  if(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  /* live pipeline - Day 0 -> Meeting light up in sequence */
  document.querySelectorAll('.seqline').forEach(function(line){
    var steps = line.querySelectorAll('.seqstep'); if(!steps.length) return;
    var idx = 0, timer = null;
    var io = new IntersectionObserver(function(en){ en.forEach(function(e){
      if(e.isIntersecting && !timer){
        timer = setInterval(function(){
          steps.forEach(function(s,k){ s.classList.toggle('seq-live', k===idx); });
          idx = (idx+1) % steps.length;
        }, 950);
      } else if(!e.isIntersecting && timer){ clearInterval(timer); timer=null; steps.forEach(function(s){ s.classList.remove('seq-live'); }); }
    }); }, { threshold: 0.35 });
    io.observe(line);
  });

  /* ROI bars grow in when scrolled into view */
  document.querySelectorAll('.bars').forEach(function(bars){
    var bs = bars.querySelectorAll('.b');
    bs.forEach(function(b){ b.dataset.h = b.style.height || getComputedStyle(b).height; b.style.height = '0%'; });
    var io = new IntersectionObserver(function(en){ en.forEach(function(e){ if(e.isIntersecting){
      bs.forEach(function(b,k){ setTimeout(function(){ b.style.height = b.dataset.h; }, k*130); });
      io.disconnect();
    } }); }, { threshold: 0.4 });
    io.observe(bars);
  });
})();

;

/* ===== v15: live extension tabs + automated Find office address ===== */
(function(){
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* automated "Find office address" - button -> searching -> result slides in */
  var findTimer = null;
  function runFind(){
    var btn = document.getElementById('findAddr');
    var searching = document.querySelector('.qs-searching');
    var result = document.querySelector('.qs-addr-result');
    if(!btn || !searching || !result) return;
    if(findTimer){ clearTimeout(findTimer); }
    var entry = document.getElementById('addrEntry'); if(entry) entry.style.display='none';
    result.hidden = true; result.classList.remove('show');
    if(reduce){ searching.hidden = true; result.hidden = false; result.classList.add('show'); return; }
    searching.hidden = false; btn.classList.add('busy');
    findTimer = setTimeout(function(){
      searching.hidden = true; btn.classList.remove('busy');
      result.hidden = false;
      requestAnimationFrame(function(){ result.classList.add('show'); });
    }, 1400);
  }
  function runSend(){
    var g=document.getElementById('sendGift'); if(!g||g.dataset.sent) return; g.dataset.sent='1';
    var qs=g.closest('.qs');
    if(!qs){ g.classList.add('sent'); g.innerHTML='<span class="pulse-dot"></span>Sent'; return; }
    if(getComputedStyle(qs).position==='static') qs.style.position='relative';
    var PLANE='<div class="pp-plane-i"><svg class="pp-svg" viewBox="0 0 120 100" xmlns="http://www.w3.org/2000/svg"><defs><linearGradient id="ppA" x1="0.1" y1="0" x2="0.9" y2="1"><stop offset="0" stop-color="#ffffff"/><stop offset="1" stop-color="#dfe5ec"/></linearGradient><linearGradient id="ppB" x1="0.1" y1="1" x2="0.9" y2="0"><stop offset="0" stop-color="#c4ccd7"/><stop offset="1" stop-color="#eef1f6"/></linearGradient><linearGradient id="ppC" x1="0" y1="0" x2="1" y2="0.6"><stop offset="0" stop-color="#aab4c2"/><stop offset="1" stop-color="#d3dae3"/></linearGradient></defs><path d="M116 51 L46 53 L28 74 Z" fill="url(#ppC)"/><path d="M116 50 L46 53 L6 92 Z" fill="url(#ppB)"/><path d="M116 50 L6 8 L46 51 Z" fill="url(#ppA)"/><path d="M116 50 L46 52" stroke="#ffffff" stroke-width="1.6" stroke-linecap="round" opacity="0.85"/><path d="M116 50 L46 53" stroke="#9aa5b4" stroke-width="0.8" opacity="0.5"/></svg></div>';
    var qr=qs.getBoundingClientRect(), gr=g.getBoundingClientRect();
    var sx=gr.left+gr.width/2-qr.left, sy=gr.top-qr.top+4;
    var res=qs.querySelector('.qs-addr-result'); var addr=(res&&!res.hidden)?(res.querySelector('.qs-addr')||res):null;
    var ex,ey;
    if(addr){ var ar=addr.getBoundingClientRect(); ex=ar.left+ar.width/2-qr.left; ey=ar.top-qr.top+ar.height*0.4; }
    else { ex=qr.width*0.5; ey=qr.height*0.32; }
    var cx=(sx+ex)/2 + Math.min(64,(qr.width-Math.max(sx,ex,10))*0.7);
    var cy=Math.min(sy,ey)-46;
    var plane=document.createElement('div'); plane.className='pp-plane'; plane.innerHTML=PLANE; qs.appendChild(plane);
    var inner=plane.firstChild;
    var t0=null, dur=1200, lastDot=0;
    function ease(t){ return t<0.5?2*t*t:1-Math.pow(-2*t+2,2)/2; }
    function frame(ts){
      if(!t0) t0=ts; var raw=Math.min((ts-t0)/dur,1), t=ease(raw), u=1-t;
      var x=u*u*sx+2*u*t*cx+t*t*ex, y=u*u*sy+2*u*t*cy+t*t*ey;
      var dxv=2*u*(cx-sx)+2*t*(ex-cx), dyv=2*u*(cy-sy)+2*t*(ey-cy);
      var ang=Math.atan2(dyv,dxv)*180/Math.PI;
      plane.style.left=x+'px'; plane.style.top=y+'px';
      inner.style.transform='translate(-50%,-50%) rotate('+ang+'deg)';
      if(ts-lastDot>26 && raw>0.02 && raw<0.97){ lastDot=ts; var d=document.createElement('span'); d.className='pp-dot'; d.style.left=x+'px'; d.style.top=y+'px'; qs.appendChild(d); d.addEventListener('animationend',function(){ d.remove(); }); }
      if(raw<1){ requestAnimationFrame(frame); }
      else {
        inner.style.transition='opacity .3s,transform .3s'; inner.style.opacity='0';
        setTimeout(function(){ plane.remove(); },340);
        g.classList.add('sent'); g.innerHTML='<span class="pulse-dot"></span>Sent';
      }
    }
    requestAnimationFrame(frame);
  }
  var fb = document.getElementById('findAddr');
  if(fb){ fb.addEventListener('click', runFind); }
  var sg = document.getElementById('sendGift'); if(sg){ sg.addEventListener('click', runSend); }

  /* live tabs - Prospect / Quick Send / Settings switch the panel */
  document.querySelectorAll('.qs-tabs').forEach(function(tabs){
    var root = tabs.parentElement;
    tabs.querySelectorAll('.qs-tab').forEach(function(t){
      t.addEventListener('click', function(){
        tabs.querySelectorAll('.qs-tab').forEach(function(x){ x.classList.remove('on'); });
        t.classList.add('on');
        var name = t.getAttribute('data-tab');
        root.querySelectorAll('.qs-body[data-panel]').forEach(function(b){ b.hidden = (b.getAttribute('data-panel') !== name); });
      });
    });
  });
  /* extension deep-dive tabs stay cosmetic (Prospect only) */
  document.querySelectorAll('.ext-tabs').forEach(function(tabs){
    tabs.querySelectorAll('.ext-tab').forEach(function(t){
      t.addEventListener('click', function(){ tabs.querySelectorAll('.ext-tab').forEach(function(x){ x.classList.remove('on'); }); t.classList.add('on'); });
    });
  });
})();

;

/* ===== v16: Prospect tab micro-interactions ===== */
(function(){
  /* Add to Navigator → "✓ Added" */
  document.querySelectorAll('.np-add').forEach(function(b){
    var orig = b.textContent;
    b.addEventListener('click', function(){
      if(b.classList.contains('np-done')) return;
      b.classList.add('np-done'); b.textContent = '✓ Added';
      setTimeout(function(){ b.classList.remove('np-done'); b.textContent = orig; }, 1800);
    });
  });
  /* Email Finder → searching → found */
  var pf = document.getElementById('pFind');
  if(pf){ pf.addEventListener('click', function(){
    if(pf.dataset.d) return; pf.dataset.d='1'; pf.textContent = 'Searching…';
    var q = document.querySelector('.np-quota'); if(q){ q.textContent = '19 left'; }
    setTimeout(function(){ pf.classList.add('np-found'); pf.textContent = '✓ m.sutton@northwind.energy'; }, 1100);
  }); }
  /* Verify email → valid */
  var pv = document.getElementById('pVerify');
  if(pv){ pv.addEventListener('click', function(){ pv.classList.add('np-ok'); pv.textContent = '✓ Valid'; }); }
  /* AI Research Brief → generating → reveal */
  var pg = document.getElementById('pGen'), pb = document.querySelector('.np-brief');
  if(pg && pb){ pg.addEventListener('click', function(){
    if(pg.dataset.d) return; pg.dataset.d='1'; pg.textContent = 'Generating…';
    setTimeout(function(){ pg.classList.add('np-done'); pg.textContent = '✓ Generated'; pb.hidden = false; }, 1300);
  }); }
})();

;

/* ===== v124: Prospect action switcher (Flight Deck / Person / Company / Sequence) ===== */
(function(){
  document.querySelectorAll('.rk-seg').forEach(function(seg){
    var card = seg.parentElement;
    seg.querySelectorAll('.rk-segb').forEach(function(b){
      b.addEventListener('click', function(){
        seg.querySelectorAll('.rk-segb').forEach(function(x){ x.classList.remove('on'); });
        b.classList.add('on');
        var n = b.getAttribute('data-act');
        card.querySelectorAll('.rk-pane').forEach(function(p){ p.hidden = (p.getAttribute('data-pane') !== n); });
      });
    });
  });
})();

;

(function(){
  var firstName=(new URLSearchParams(location.search).get("name")||"").trim();
  /* Mockup only: choices held in memory. In production, store a consent cookie + honour it. */
  var consent={essential:true,analytics:false,personalisation:false};
  var cookie=document.getElementById("cookie");
  var prefs=document.getElementById("ckPrefs");
  var swA=document.getElementById("swAnalytics");
  var swP=document.getElementById("swPersonal");
  var bar=document.getElementById("greetbar");

  function timeGreeting(){var h=new Date().getHours();
    if(h<12)return{g:"Good morning",e:"☀️"};
    if(h<18)return{g:"Good afternoon",e:"👋"};
    return{g:"Good evening",e:"🌙"};}
  function cityFromTZ(){try{var tz=Intl.DateTimeFormat().resolvedOptions().timeZone||"";
    var c=tz.split("/").pop().replace(/_/g," ");
    if(!c||/^(GMT|UTC|Etc|Universal)/i.test(c))return"";return c;}catch(e){return"";}}
  var days=["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];
  var fun={
    Monday:["Happy Monday!","New week, fresh pipeline. Let us make it count. ☕"],
    Tuesday:["Terrific Tuesday!","Coffee in, deals to win. 🚀"],
    Wednesday:["Happy Hump Day!","Halfway there, keep the momentum going. 🐫"],
    Thursday:["Thriving Thursday!","Nearly the weekend, plenty still to send. 📮"],
    Friday:["Finally Friday!","End the week on a high note. 🎉"],
    Saturday:["Super Saturday!","Weekend mode: on. Thanks for stopping by. 🌤️"],
    Sunday:["Sunday, sorted.","A calm one to you, ready when Monday is. 🌿"]
  };

  function showGreeting(){
    var main,sub,wave;
    if(consent.personalisation){
      var tg=timeGreeting(),who=firstName?(", "+firstName):"",city=cityFromTZ();
      main=tg.g+who; wave=tg.e;
      sub=city?("Hope "+city+" is treating you well today."):"Lovely to have you here today.";
    }else{
      var f=fun[days[new Date().getDay()]]; main=f[0]; sub=f[1]; wave="✨";
    }
    document.getElementById("gwave").textContent=wave;
    document.getElementById("gmain").textContent=main;
    document.getElementById("gsub").textContent=sub;
    bar.classList.add("show");
  }
  function hideBanner(){cookie.classList.remove("show");}
  function openBanner(){cookie.classList.add("show");}
  function setSw(sw,on){sw.classList.toggle("on",on);sw.setAttribute("aria-checked",on?"true":"false");}

  document.getElementById("ckAccept").addEventListener("click",function(){
    consent.analytics=true;consent.personalisation=true;hideBanner();showGreeting();});
  document.getElementById("ckReject").addEventListener("click",function(){
    consent.analytics=false;consent.personalisation=false;hideBanner();showGreeting();});
  document.getElementById("ckManageBtn").addEventListener("click",function(){prefs.classList.toggle("show");});
  swA.addEventListener("click",function(){setSw(swA,!swA.classList.contains("on"));});
  swP.addEventListener("click",function(){setSw(swP,!swP.classList.contains("on"));});
  document.getElementById("ckSave").addEventListener("click",function(){
    consent.analytics=swA.classList.contains("on");
    consent.personalisation=swP.classList.contains("on");
    hideBanner();showGreeting();});
  var gclose=document.getElementById("gclose");if(gclose)gclose.addEventListener("click",function(){bar.classList.remove("show");});
  var reopen=document.getElementById("ckReopen");
  if(reopen)reopen.addEventListener("click",function(){setSw(swA,consent.analytics);setSw(swP,consent.personalisation);openBanner();});

  setTimeout(openBanner,700);
})();

;

(function(){
  var phrases=[
    "close more deals","build more pipeline","book more meetings","make warm introductions",
    "warm up cold prospects","get ghosted prospects to reply","reach the decision-maker",
    "unstick stalled deals","shorten the sales cycle","upsell existing clients",
    "keep clients for longer","win back lost customers","nurture your key accounts",
    "renew more contracts","onboard new clients","say thank you properly",
    "reward your top performers","fill your events","stand out at trade shows",
    "put your hero product in their hands","make your brand unforgettable",
    "win over new hires","recruit hard-to-get talent","turn a cold list warm"
  ];
  var el=document.getElementById("tw"); if(!el) return;
  var line=document.querySelector(".tw-line"), inner=document.querySelector(".tw-inner");
  function fit(){ if(line&&inner) line.style.height=inner.offsetHeight+"px"; }
  window.addEventListener("resize",fit); fit();
  var reduce=window.matchMedia&&window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if(reduce){ el.textContent=phrases[0]; fit(); return; }
  var i=0;
  function type(){
    var w=phrases[i], j=0;
    (function add(){
      el.textContent=w.slice(0,++j); fit();
      if(j<w.length) setTimeout(add,50);
      else setTimeout(del,1500);
    })();
  }
  function del(){
    var w=el.textContent;
    (function rm(){
      w=w.slice(0,-1); el.textContent=w; fit();
      if(w.length) setTimeout(rm,28);
      else { i=(i+1)%phrases.length; setTimeout(type,300); }
    })();
  }
  setTimeout(type,500);
})();

;

document.addEventListener("DOMContentLoaded",function(){
  document.querySelectorAll(".gl-tabs").forEach(function(tabs){
    var body=tabs.parentElement;
    tabs.querySelectorAll(".gl-tab").forEach(function(t){
      t.addEventListener("click",function(){
        tabs.querySelectorAll(".gl-tab").forEach(function(x){x.classList.remove("on");});
        t.classList.add("on");
        var n=t.getAttribute("data-gl");
        body.querySelectorAll(".gl-panel").forEach(function(pn){ pn.hidden = pn.getAttribute("data-glp")!==n; });
      });
    });
  });
  document.querySelectorAll('.gl-panel[data-glp="featured"] .gl-card').forEach(function(c){
    c.addEventListener("click",function(){
      var grid=c.parentElement;
      grid.querySelectorAll(".gl-card").forEach(function(x){x.classList.remove("sel");});
      c.classList.add("sel");
    });
  });
});

;

document.addEventListener("DOMContentLoaded",function(){
  document.querySelectorAll(".pv-bgs").forEach(function(bgs){
    bgs.querySelectorAll(".pvb").forEach(function(b){
      b.addEventListener("click",function(){
        bgs.querySelectorAll(".pvb").forEach(function(x){x.classList.remove("on");});
        b.classList.add("on");
      });
    });
  });
  document.querySelectorAll(".pv-tg").forEach(function(t){
    t.addEventListener("click",function(){
      t.classList.toggle("on");
      var on=t.classList.contains("on");
      var v=t.closest(".frame")?t.closest(".frame").querySelector(".pv-video"):null;
      if(v){ v.classList.toggle("noframe", !on); var tag=v.querySelector(".pv-frtag"); if(tag) tag.textContent="Branded frame · "+(on?"on":"off"); }
    });
  });
});

;

document.addEventListener("DOMContentLoaded",function(){
  var ROCKET='<div class="rk-inner"><svg class="rk-svg" viewBox="0 0 80 176" xmlns="http://www.w3.org/2000/svg"><defs><linearGradient id="rkb" x1="0" y1="0" x2="1" y2="0"><stop offset="0" stop-color="#eef3f9"/><stop offset=".5" stop-color="#ffffff"/><stop offset="1" stop-color="#c6d0dc"/></linearGradient><linearGradient id="rkf" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#fff3b0"/><stop offset=".5" stop-color="#ff9d2e"/><stop offset="1" stop-color="#ff4d2e"/></linearGradient></defs><g class="rk-flame"><path d="M31 118 C31 140 36 168 40 174 C44 168 49 140 49 118 Z" fill="url(#rkf)"/><path d="M35 120 C35 136 38 154 40 160 C42 154 45 136 45 120 Z" fill="#ffe28a"/></g><path d="M27 96 L14 126 L30 118 Z" fill="#e23b34"/><path d="M53 96 L66 126 L50 118 Z" fill="#e23b34"/><path d="M40 6 C58 30 58 74 52 116 L28 116 C22 74 22 30 40 6 Z" fill="url(#rkb)" stroke="#b3bfcc" stroke-width="1.4"/><path d="M40 6 C50 22 54 42 54 56 L26 56 C26 42 30 22 40 6 Z" fill="#e23b34"/><circle cx="40" cy="72" r="11" fill="#bfe3ff" stroke="#3f7fb5" stroke-width="3"/><circle cx="36" cy="68" r="3.2" fill="#fff" opacity=".85"/><rect x="27" y="112" width="26" height="8" rx="3" fill="#b3bfcc"/></svg></div>';
  var PLAY='<svg class="icn"><use href="#g-play"/></svg>';
  var PAUSE='<svg viewBox="0 0 24 24" width="20" height="20" style="fill:currentColor"><rect x="6" y="4.5" width="4.2" height="15" rx="1.3"/><rect x="13.8" y="4.5" width="4.2" height="15" rx="1.3"/></svg>';

  function burst(el,color,n){
    var host=el.closest(".phone")||document.body;
    if(getComputedStyle(host).position==="static") host.style.position="relative";
    var er=el.getBoundingClientRect(), hr=host.getBoundingClientRect();
    var cx=er.left+er.width/2-hr.left, cy=er.top+er.height/2-hr.top;
    for(var i=0;i<(n||3);i++){ (function(d){ setTimeout(function(){
      var r=document.createElement("span"); r.className="epic-ring";
      r.style.left=cx+"px"; r.style.top=cy+"px"; r.style.color=color;
      host.appendChild(r); r.addEventListener("animationend",function(){ r.remove(); });
    }, d*130); })(i); }
  }

  /* I'm interested -> realistic rocket + liftoff smoke */
  document.querySelectorAll(".lpd-int").forEach(function(btn){
    btn.addEventListener("click",function(){
      var r=document.createElement("div"); r.className="rocket-fly"; r.innerHTML=ROCKET;
      document.body.appendChild(r); r.addEventListener("animationend",function(){ r.remove(); });
      for(var i=0;i<4;i++){ (function(d){ setTimeout(function(){
        var sm=document.createElement("div"); sm.className="rk-smoke";
        sm.style.marginLeft=((d%2?1:-1)*(8+d*4))+"px";
        document.body.appendChild(sm); sm.addEventListener("animationend",function(){ sm.remove(); });
      }, d*70); })(i); }
    });
  });

  /* Play -> epic play (ripple, zoom, flash, progress, pause toggle) */
  document.querySelectorAll(".lpd-play").forEach(function(pl){
    pl.addEventListener("click",function(e){
      e.stopPropagation();
      var vt=pl.closest(".lpd-vthumb");
      var playing=vt.classList.toggle("playing");
      burst(pl,"#ffffff",3);
      pl.classList.remove("pulse"); void pl.offsetWidth; pl.classList.add("pulse");
      pl.innerHTML = playing ? PAUSE : PLAY;
    });
  });

  /* Reply -> epic recording */
  document.querySelectorAll(".lpd-reply").forEach(function(rp){
    var orig=rp.innerHTML;
    rp.addEventListener("click",function(){
      if(rp.dataset.rec) return; rp.dataset.rec="1";
      burst(rp,"#ffffff",3);
      rp.classList.add("recording");
      rp.innerHTML='<span class="rec-dot"></span>Recording your reply…';
      setTimeout(function(){ rp.classList.remove("recording"); rp.innerHTML='<svg class="icn"><use href="#g-check"/></svg>Reply sent'; }, 2600);
      setTimeout(function(){ rp.innerHTML=orig; rp.dataset.rec=""; }, 4600);
    });
  });

  /* Add to contacts -> simulate saving to phone */
  document.querySelectorAll(".lpd-ghost").forEach(function(gb){
    gb.addEventListener("click",function(){
      if(gb.dataset.added) return; gb.dataset.added="1";
      var phone=gb.closest(".phone");
      gb.innerHTML='<span><span class="ct-spin"></span> Adding to contacts…</span>';
      setTimeout(function(){
        var t=document.createElement("div"); t.className="ct-toast";
        t.innerHTML='<span class="ct-av">MR</span><div><b>Mark Reynolds</b><span>✓ Added to Contacts</span></div>';
        if(phone){ if(getComputedStyle(phone).position==="static") phone.style.position="relative"; phone.appendChild(t); }
        gb.classList.add("added");
        gb.innerHTML='<span><svg class="icn"><use href="#g-check"/></svg> Added to your contacts</span><small>Saved to your phone</small>';
        setTimeout(function(){ t.classList.add("out"); setTimeout(function(){ t.remove(); },420); }, 1900);
      }, 850);
    });
  });
});

;

document.addEventListener("DOMContentLoaded",function(){
  function ensureRel(el){ if(getComputedStyle(el).position==="static") el.style.position="relative"; el.style.overflow="visible"; el.style.cursor="pointer"; }
  function rings(el,color,n){ for(var i=0;i<(n||2);i++){ (function(d){ setTimeout(function(){
    var r=document.createElement("span"); r.className="epic-ring"; r.style.left="50%"; r.style.top="50%"; r.style.color=color||"#1e72b8";
    el.appendChild(r); r.addEventListener("animationend",function(){ r.remove(); });
  }, d*130); })(i); } }
  function floatUp(el,txt){ var f=document.createElement("span"); f.className="epic-float"; f.textContent=txt; el.appendChild(f); f.addEventListener("animationend",function(){ f.remove(); }); }
  function pulse(el){ el.classList.remove("epic-pulse"); void el.offsetWidth; el.classList.add("epic-pulse"); }

  var pills=document.querySelectorAll(".roi-pills span");
  if(pills[0]){ ensureRel(pills[0]); pills[0].addEventListener("click",function(){ rings(pills[0],"#7ee0a6",2); floatUp(pills[0],"🛡️"); pulse(pills[0]); }); }
  if(pills[1]){ ensureRel(pills[1]); pills[1].addEventListener("click",function(){ rings(pills[1],"#bfe3ff",2); floatUp(pills[1],"🤝"); pulse(pills[1]); }); }

  function floatAt(el,txt,dx,delay){ setTimeout(function(){ var f=document.createElement("span"); f.className="epic-float"; f.textContent=txt; f.style.setProperty("--dx",(dx||0)+"px"); el.appendChild(f); f.addEventListener("animationend",function(){f.remove();}); }, delay||0); }
  function animIcon(el,cls){ var ic=el.querySelector(".icn"); if(ic){ ic.classList.remove(cls); void ic.offsetWidth; ic.classList.add(cls); } }
  function moveEl(el,txt,cls){ var s=document.createElement("span"); s.className=cls; s.textContent=txt; el.appendChild(s); s.addEventListener("animationend",function(){s.remove();}); }
  function bindBadge(el,fn){ if(!el) return function(){}; ensureRel(el); var busy=false;
    function run(){ if(busy) return; busy=true; fn(); setTimeout(function(){busy=false;},1100); }
    el.addEventListener("click",run); return run; }

  var pb=document.querySelectorAll(".perf .badge");
  var trig=[];
  // Plans that scale with your team -> the team grows
  trig.push(bindBadge(pb[0],function(){ animIcon(pb[0],"epic-grow"); rings(pb[0],"#bfe3ff",1); floatAt(pb[0],"👤",-20,0); floatAt(pb[0],"👥",0,110); floatAt(pb[0],"👤",20,220); pulse(pb[0]); }));
  // Credit only spent on delivery -> truck delivers, then credit is spent
  trig.push(bindBadge(pb[1],function(){ rings(pb[1],"#bfe3ff",1); moveEl(pb[1],"🚚","epic-drive"); floatAt(pb[1],"💳",24,640); pulse(pb[1]); }));
  // Credit rolls over -> coin rolls across
  trig.push(bindBadge(pb[2],function(){ animIcon(pb[2],"epic-spin"); rings(pb[2],"#bfe3ff",1); moveEl(pb[2],"🪙","epic-roll"); pulse(pb[2]); }));

  function fmtT(s){ var m=Math.floor(s/60), ss=s%60; return m+":"+(ss<10?"0":"")+ss; }
  document.querySelectorAll(".pv-start").forEach(function(rb){
    var orig=rb.innerHTML, tick=null, badge=null, rec=null, recHTML=null;
    rb.addEventListener("click",function(){
      var host=rb.closest(".frame")||document, vid=host.querySelector(".pv-video");
      if(!rb.dataset.rec){
        rb.dataset.rec="1"; ensureRel(rb); rings(rb,"#ffffff",3);
        rb.classList.add("pv-recording"); rb.innerHTML='<span class="rec-dot"></span>Stop recording';
        if(vid){ badge=document.createElement("span"); badge.className="pv-recbadge"; badge.innerHTML="<i></i>REC"; vid.appendChild(badge); }
        rec=host.querySelector(".pv-rec"); recHTML=rec?rec.innerHTML:null;
        if(rec){ var base=(rec.textContent.trim().match(/(\d+):(\d+)/)); var secs=base?(+base[1]*60+ +base[2]):24;
          tick=setInterval(function(){ secs++; rec.innerHTML='<i></i>'+fmtT(secs); }, 1000); }
      } else {
        rb.classList.remove("pv-recording"); rb.innerHTML=orig; rb.dataset.rec="";
        if(badge){ badge.remove(); badge=null; }
        if(tick){ clearInterval(tick); tick=null; }
        if(rec&&recHTML!=null){ rec.innerHTML=recHTML; }
      }
    });
  });
  document.querySelectorAll(".pv-altbtn").forEach(function(lb){
    lb.addEventListener("click",function(){
      if(lb.dataset.busy) return; lb.dataset.busy="1"; ensureRel(lb); pulse(lb);
      var xs=[-24,0,24], rot=[-13,0,13];
      for(var i=0;i<3;i++){ (function(i){ setTimeout(function(){
        var t=document.createElement("span"); t.className="lib-thumb";
        t.style.setProperty("--dx",xs[i]+"px"); t.style.setProperty("--rot",rot[i]+"deg");
        lb.appendChild(t); t.addEventListener("animationend",function(){ t.remove(); });
      }, i*85); })(i); }
      setTimeout(function(){ lb.dataset.busy=""; }, 950);
    });
  });
});

;

document.addEventListener("DOMContentLoaded",function(){
  (function(){
    var lab=document.querySelector('.gl-panel[data-glp="lab"]'); if(!lab) return;
    var typeEl=lab.querySelector('.gl-type'), results=lab.querySelector('.gl-results'), resline=lab.querySelector('.gl-resline');
    var P=[{"img": RKMEDIA["m7"], "nm": "Grays Sports Almanac: Back To The Future 2", "pr": "&pound;12.15"}, {"img": RKMEDIA["m8"], "nm": "PASS THE PIGS Dice Game, classic party &amp; travel game", "pr": "&pound;10.50"}, {"img": RKMEDIA["m9"], "nm": "Professor Snape's Potion Bottles Mood Lamp", "pr": "&pound;20.60"}, {"img": RKMEDIA["m10"], "nm": "Personalised Toblerone bar with Name &amp; Message", "pr": "&pound;18.99"}, {"img": RKMEDIA["m32"], "nm": "Glass Cocktail Shaker Kit, Clear Drink Mixer", "pr": "&pound;11.99"}, {"img": RKMEDIA["m33"], "nm": "Cocktail Shaker Maker Set, 750ml Strainer", "pr": "&pound;12.29"}, {"img": RKMEDIA["m34"], "nm": "2 Pcs Cocktail Shaker Making Set with Recipes", "pr": "&pound;12.99"}, {"img": RKMEDIA["m35"], "nm": "5 Pcs Cocktail Muddler Set, Bar Spoon &amp; Tongs", "pr": "&pound;11.59"}, {"img": RKMEDIA["m36"], "nm": "International Food Hamper | Premium Exotic Foods", "pr": "&pound;25.99"}, {"img": RKMEDIA["m37"], "nm": "Paladone R2-D2 Travel Mug, Star Wars Flask", "pr": "&pound;15.99"}, {"img": RKMEDIA["m38"], "nm": "Travelling the World Survival Kit", "pr": "&pound;10.99"}, {"img": RKMEDIA["m39"], "nm": "Personalised Mug, Photo Text Logo", "pr": "&pound;11.90"}, {"img": RKMEDIA["m40"], "nm": "Mrs Crimble's Gluten Free Belgian Brownies", "pr": "&pound;4.90"}, {"img": RKMEDIA["m41"], "nm": "Hy-Pro Size 5 Nova Premium Football", "pr": "&pound;18.00"}, {"img": RKMEDIA["m42"], "nm": "Fortnum &amp; Mason Marmalade Trio Gift Pack", "pr": "&pound;26.00"}, {"img": RKMEDIA["m43"], "nm": "Tilz Hot Sauce Gift Set, 12pk Chilli", "pr": "&pound;17.99"}], S=[{"q": "Fun novelty gifts", "count": "Showing <b>512</b> results · page 1 of 11", "idx": [0, 1, 2, 3]}, {"q": "Cocktail making kit", "count": "Showing <b>736</b> results · page 1 of 16", "idx": [4, 5, 6, 7]}, {"q": "Premium hampers & treats", "count": "Showing <b>289</b> results · page 1 of 7", "idx": [8, 14, 15, 12]}, {"q": "Fan favourites", "count": "Showing <b>634</b> results · page 1 of 14", "idx": [9, 13, 10, 11]}];
    function card(p){ return '<div class="gl-res"><div class="img"><img src="'+p.img+'" alt=""></div><div class="meta"><div class="nm">'+p.nm+'</div><div class="rrow"><span class="pr">'+p.pr+'</span><button class="addg">Add to gift</button></div></div></div>'; }
    function render(sc){ results.style.transition='opacity .22s ease'; results.style.opacity=0; setTimeout(function(){ results.innerHTML=sc.idx.map(function(i){return card(P[i]);}).join(''); resline.innerHTML=sc.count; results.style.opacity=1; },200); }
    function sleep(ms){ return new Promise(function(r){ setTimeout(r,ms); }); }
    typeEl.textContent=S[0].q; render(S[0]);
    var si=0;
    (async function(){
      await sleep(2600);
      while(true){
        var q=S[si].q;
        for(var k=q.length;k>=0;k--){ typeEl.textContent=q.slice(0,k); await sleep(30); }
        await sleep(280);
        si=(si+1)%S.length;
        var q2=S[si].q;
        for(var m=1;m<=q2.length;m++){ typeEl.textContent=q2.slice(0,m); await sleep(58); }
        await sleep(240);
        render(S[si]);
        await sleep(2900);
      }
    })();
    results.addEventListener('click',function(e){
      var btn=e.target.closest('.addg'); if(!btn||btn.dataset.on) return; btn.dataset.on='1';
      var orig=btn.textContent; btn.classList.add('pop'); setTimeout(function(){btn.classList.remove('pop');},160);
      btn.classList.add('added'); btn.textContent='\u2713 Added';
      setTimeout(function(){ btn.classList.remove('added'); btn.textContent=orig; btn.dataset.on=''; },1500);
    });
  })();
});

;

document.addEventListener("DOMContentLoaded",function(){
  function setPlaybook(name,gift,emoji,price){
    var sel=document.getElementById("qsPlaybook"); if(!sel) return;
    var txt=sel.querySelector(".qs-pbtext"), req=document.getElementById("qsReq"), g=document.querySelector(".qs-gift.pb-gift");
    if(txt){ sel.classList.remove("placeholder"); txt.textContent=name; }
    if(req){ req.textContent="Selected"; req.classList.add("done"); }
    if(g){ var gi=g.querySelector(".gi"), gn=g.querySelector(".gn"), gp=g.querySelector(".gp");
      if(gi&&emoji) gi.textContent=emoji; if(gn&&gift) gn.innerHTML=gift; if(gp&&price) gp.textContent=price;
      g.classList.add("show"); }
    sel.classList.add("pb-flash"); setTimeout(function(){ sel.classList.remove("pb-flash"); },700);
    document.querySelectorAll("#qsOptions .qs-opt").forEach(function(o){ o.classList.toggle("on", o.textContent.trim()===name); });
  }
  function runPlaybook(){
    var sel=document.getElementById("qsPlaybook"); if(!sel) return;
    var txt=sel.querySelector(".qs-pbtext"), req=document.getElementById("qsReq"), g=document.querySelector(".qs-gift.pb-gift");
    if(!txt) return;
    sel.classList.add("placeholder"); txt.textContent="Select a playbook\u2026";
    if(req){ req.textContent="Required"; req.classList.remove("done"); }
    if(g) g.classList.remove("show");
    setTimeout(function(){ setPlaybook("Welcome Gift: Notebook & Pen","Moleskine &amp; Pen (with letter)","🎁","£26"); }, 1200);
  }
  // dropdown open/close + selection
  (function(){
    var dd=document.getElementById("qsDD"), sel=document.getElementById("qsPlaybook"), opts=document.getElementById("qsOptions");
    if(dd&&sel&&opts){
      sel.addEventListener("click",function(e){ e.stopPropagation(); var open=dd.classList.toggle("open"); opts.hidden=!open; });
      opts.querySelectorAll(".qs-opt").forEach(function(o){
        o.addEventListener("click",function(e){ e.stopPropagation();
          setPlaybook(o.textContent.trim(), o.getAttribute("data-gift"), o.getAttribute("data-emoji"), o.getAttribute("data-price"));
          dd.classList.remove("open"); opts.hidden=true;
        });
      });
      document.addEventListener("click",function(){ dd.classList.remove("open"); opts.hidden=true; });
    }
  })();
  setTimeout(runPlaybook, 800);
  document.querySelectorAll('.qs-tab[data-tab="quicksend"]').forEach(function(t){ t.addEventListener("click",function(){ setTimeout(runPlaybook,150); }); });
});

;

document.addEventListener("DOMContentLoaded",function(){
  function addDot(el){ if(!el||el.querySelector(".tab-dot")) return;
    var d=document.createElement("span"); d.className="tab-dot"; el.appendChild(d);
    el.addEventListener("click",function(){ var dot=el.querySelector(".tab-dot"); if(dot) dot.remove(); });
  }
  document.querySelectorAll(".qs-tab").forEach(function(t){ var n=t.getAttribute("data-tab"); if(n==="prospect"||n==="settings") addDot(t); });
  document.querySelectorAll(".ds-tab").forEach(function(t){ if(!t.classList.contains("on")) addDot(t); });
});

;

document.addEventListener("DOMContentLoaded",function(){
  var burger=document.querySelector(".hamburger"), navM=document.getElementById("navMobile");
  if(burger&&navM){
    burger.addEventListener("click",function(){ var open=navM.classList.toggle("open"); burger.setAttribute("aria-expanded",open?"true":"false"); });
    navM.querySelectorAll("a").forEach(function(a){ a.addEventListener("click",function(){ navM.classList.remove("open"); burger.setAttribute("aria-expanded","false"); }); });
  }
});

;

document.addEventListener("DOMContentLoaded",function(){
  function rel(el){ if(getComputedStyle(el).position==="static") el.style.position="relative"; el.style.overflow="visible"; }
  function ring(el,color){ var r=document.createElement("span"); r.className="epic-ring"; r.style.left="50%"; r.style.top="50%"; r.style.color=color||"#fff"; el.appendChild(r); r.addEventListener("animationend",function(){r.remove();}); }
  function floatUp(el,txt){ var f=document.createElement("span"); f.className="epic-float"; f.textContent=txt; el.appendChild(f); f.addEventListener("animationend",function(){f.remove();}); }
  function pop(el){ el.classList.remove("epic-pulse"); void el.offsetWidth; el.classList.add("epic-pulse"); }
  document.querySelectorAll(".ds-lp-video").forEach(function(vid){
    var pb=vid.querySelector(".ds-lp-play"); if(!pb) return; rel(pb);
    var prog=vid.querySelector(".ds-lp-prog");
    if(!prog){ prog=document.createElement("span"); prog.className="ds-lp-prog"; vid.appendChild(prog); }
    var playing=false, t1=null;
    function stop(){ playing=false; vid.classList.remove("playing"); prog.style.transition="width .3s ease"; prog.style.width="0"; if(t1){clearTimeout(t1);t1=null;} }
    function start(){ playing=true; ring(pb,"#ffffff"); vid.classList.add("playing");
      prog.style.transition="none"; prog.style.width="0"; void prog.offsetWidth;
      prog.style.transition="width 5s linear"; prog.style.width="100%";
      t1=setTimeout(stop,5000); }
    vid.style.cursor="pointer";
    vid.addEventListener("click",function(){ playing?stop():start(); });
  });
  document.querySelectorAll(".ds-lp-btn").forEach(function(bb){
    rel(bb); var o=bb.innerHTML;
    bb.addEventListener("click",function(){ if(bb.dataset.b) return; bb.dataset.b="1"; ring(bb,"#ffffff"); floatUp(bb,"📅"); pop(bb);
      bb.classList.add("dslp-done"); bb.innerHTML='<svg class="icn"><use href="#g-check"/></svg>Booked, confirmed';
      setTimeout(function(){ bb.innerHTML=o; bb.classList.remove("dslp-done"); bb.dataset.b=""; },1900); });
  });
  var chips=document.querySelectorAll(".ds-lp-chip");
  if(chips[0]){ rel(chips[0]); chips[0].addEventListener("click",function(){ if(chips[0].dataset.b) return; chips[0].dataset.b="1";
    ring(chips[0],"#ffe08a"); floatUp(chips[0],"\u2b50"); pop(chips[0]); chips[0].classList.add("dslp-int");
    setTimeout(function(){ chips[0].classList.remove("dslp-int"); chips[0].dataset.b=""; },1500); }); }
  if(chips[1]){ rel(chips[1]); var o1=chips[1].innerHTML; chips[1].addEventListener("click",function(){ if(chips[1].dataset.b) return; chips[1].dataset.b="1";
    ring(chips[1],"#7ee0a6"); pop(chips[1]); chips[1].classList.add("dslp-saved"); chips[1].innerHTML='<svg class="icn"><use href="#g-check"/></svg>Saved';
    setTimeout(function(){ chips[1].innerHTML=o1; chips[1].classList.remove("dslp-saved"); chips[1].dataset.b=""; },1500); }); }
});

;

document.addEventListener("DOMContentLoaded",function(){
  function rkPostContact(f){var _h=document.querySelector('.rk-hp');if(_h&&_h.value)return;try{var b=['form_type=contact','utf8=%E2%9C%93'];for(var k in f){b.push('contact['+encodeURIComponent(k)+']='+encodeURIComponent(f[k]||''));}fetch('/contact',{method:'POST',headers:{'Content-Type':'application/x-www-form-urlencoded'},body:b.join('&')});}catch(e){}}
  var nf=document.getElementById("footNews"), fe=document.getElementById("footEmail");var _hp=document.createElement('input');_hp.type='text';_hp.name='url';_hp.className='rk-hp';_hp.tabIndex=-1;_hp.setAttribute('autocomplete','off');_hp.setAttribute('aria-hidden','true');_hp.style.cssText='position:absolute;left:-9999px;top:auto;width:1px;height:1px;opacity:0;pointer-events:none';if(nf){nf.appendChild(_hp);}
  if(nf&&fe){ nf.addEventListener("submit",function(){ var v=fe.value.trim();
    if(/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)){ rkPostContact({email:v,'Request type':'Newsletter subscribe',body:'New newsletter subscriber from the site footer.'}); nf.innerHTML='<span class="fn-done"><svg class="icn"><use href="#g-check-circle"/></svg>You\u2019re in. Watch your inbox.</span>'; }
    else { fe.focus(); fe.style.borderColor="#e05a5a"; }
  }); fe.addEventListener("input",function(){ fe.style.borderColor=""; }); }
  var bt=document.getElementById("backTop");
  if(bt){ bt.addEventListener("click",function(){ window.scrollTo({top:0,behavior:"smooth"}); }); }
});

;

document.addEventListener("DOMContentLoaded",function(){
  document.querySelectorAll(".na-app").forEach(function(app){
    app.querySelectorAll(".na-tab").forEach(function(t){
      t.addEventListener("click",function(){
        app.querySelectorAll(".na-tab").forEach(function(x){x.classList.remove("on");});
        t.classList.add("on");
        var n=t.getAttribute("data-nt");
        app.querySelectorAll(".na-panel").forEach(function(p){ p.hidden = p.getAttribute("data-ntp")!==n; });
      });
    });

    // Relevant click animation for every clickable control inside Navigator
    function play(el,cls){ if(!el) return; el.classList.remove(cls); void el.offsetWidth; el.classList.add(cls);
      el.addEventListener("animationend",function h(){ el.classList.remove(cls); el.removeEventListener("animationend",h); }); }
    var GLYPH={ "#g-mail":"naa-fly", "#g-rocket":"naa-launch", "#g-link":"naa-launch", "#g-refresh":"naa-spin",
      "#g-plus":"naa-spin", "#g-list":"naa-bump", "#g-file":"naa-down", "#g-target":"naa-pop",
      "#g-message":"naa-pop", "#g-check-circle":"naa-pop", "#g-search":"naa-pop" };
    function iconAnim(btn){ var u=btn.querySelector("use"); if(!u) return; var h=u.getAttribute("href")||u.getAttribute("xlink:href")||"";
      var cls=GLYPH[h]; if(cls) play(btn.querySelector(".icn"),cls); }

    var PB_LETTERS={"Warm": "Hi {First Name},\n\nI have been meaning to reach out to {Company} for a while, and I wanted to do it properly rather than with another cold email you would scroll straight past.\n\nI really rate what your team is building, so I have popped a small gift in the post as a genuine thank you. No strings, it is yours to keep.\n\nIf it puts a smile on your face and you fancy a chat, I would love twenty minutes to show how teams like yours use Rockkt. If not, no worries at all.\n\nWarmly,\nSophie", "Formal": "Dear {First Name},\n\nI am writing to introduce Rockkt to {Company}, as I believe there is a strong fit between our platform and your team's objectives this year.\n\nAs a gesture of good faith, I have arranged for a small gift to be delivered to you, offered with no obligation whatsoever.\n\nShould the timing suit, I would welcome a brief twenty-minute conversation to demonstrate how organisations comparable to {Company} use Rockkt to increase engagement and secure more meetings.\n\nKind regards,\nSophie", "Playful": "Hi {First Name},\n\nPlot twist: this is not another cold email begging for your calendar. It is a genuine hello from someone who thinks {Company} is doing brilliant things.\n\nSo I did something old fashioned and sent you an actual gift. In the actual post. Wild, I know.\n\nIf it makes your day even a little better, and you are curious how teams like yours use Rockkt to book more meetings, I am one reply away. If not, enjoy the freebie on me.\n\nCheers,\nSophie", "Direct": "Hi {First Name},\n\nQuick and honest: I think Rockkt can help {Company} book more meetings, and I would rather show you than tell you.\n\nI have sent you a small gift, no strings attached. If it lands well, give me twenty minutes and I will prove the point. If not, keep the gift and we will leave it there.\n\nBest,\nSophie", "Concise": "Hi {First Name},\n\nI have sent {Company} a small gift, no strings attached. If you like it, I would love twenty minutes to show how Rockkt helps teams like yours book more meetings.\n\nEither way, enjoy it.\n\nBest,\nSophie"};
    function pbTone(){ var sel=app.querySelector(".pb-tone"); return (sel&&PB_LETTERS[sel.value])?sel.value:"Warm"; }
    function pbCount(){ var ta=app.querySelector(".pb-ta"); if(ta){ var c=app.querySelector(".pb-count"); if(c) c.textContent=ta.value.length+"/600"; } }
    var pbTa=app.querySelector(".pb-ta"); if(pbTa){ pbTa.addEventListener("input",pbCount); }
    var pbToneSel=app.querySelector(".pb-tone"); if(pbToneSel){ pbToneSel.addEventListener("change",function(){ if(pbTa && pbTa.value.trim()){ pbTa.value=PB_LETTERS[pbTone()]; pbCount(); } }); }

    app.addEventListener("click",function(e){
      var t;
      if(t=e.target.closest(".pb-gtab")){ var host=t.closest(".pb-form"); t.parentNode.querySelectorAll(".pb-gtab").forEach(function(x){x.classList.remove("on");}); t.classList.add("on"); var pk=t.getAttribute("data-pg"); host.querySelectorAll(".pb-gpanel").forEach(function(pn){ pn.hidden=pn.getAttribute("data-pgp")!==pk; }); play(t,"naa-press"); return; }
      if(t=e.target.closest(".pb-ladd")){ play(t,"naa-pop"); return; }
      if(t=e.target.closest(".pb-lpers")){ play(t.querySelector(".icn"),"naa-pop"); return; }
      if(t=e.target.closest(".pb-ldet")){ play(t,"naa-press"); return; }
      if(t=e.target.closest(".pb-card")){ t.parentNode.querySelectorAll(".pb-card").forEach(function(x){x.classList.remove("sel");}); t.classList.add("sel"); play(t,"naa-pop"); return; }
      if(t=e.target.closest(".pb-tag")){ var ta=app.querySelector(".pb-ta"); if(ta){ var tok=t.getAttribute("data-tok"); ta.value=(ta.value?ta.value+" ":"")+tok; pbCount(); } play(t,"naa-pop"); return; }
      if(t=e.target.closest(".pb-gen")){ var ta2=app.querySelector(".pb-ta"); if(ta2){ ta2.value=PB_LETTERS[pbTone()]; pbCount(); } play(t.querySelector(".icn"),"naa-pop"); play(t,"naa-press"); return; }
      if(t=e.target.closest(".oh-toggle")){ t.classList.toggle("on"); return; }
      if(t=e.target.closest(".oh-deal")){ play(t.querySelector(".icn"),"naa-spin"); play(t,"naa-press"); return; }
      if(t=e.target.closest(".oh-chip")){ play(t,"naa-pop"); return; }
      if(t=e.target.closest(".oh-track")){ play(t.querySelector(".icn"),"naa-launch"); return; }
      if(t=e.target.closest(".oh-cancel")){ play(t,"naa-shake"); return; }
      if(t=e.target.closest(".oh-dval .icn")){ play(t,"naa-pop"); return; }
      if(t=e.target.closest(".roi-edit")){ play(t.querySelector(".icn"),"naa-pop"); play(t,"naa-press"); return; }
      if(t=e.target.closest(".roi-exp")){ var open=t.classList.toggle("rot"); t.style.transform=open?"rotate(180deg)":""; return; }
      if(t=e.target.closest(".na-check")){ t.classList.toggle("on"); return; }
      if(t=e.target.closest(".na-del")){ play(t.querySelector(".icn")||t,"naa-shake"); return; }
      if(t=e.target.closest(".na-snz")){ play(t.querySelector(".icn")||t,"naa-spin"); return; }
      if(t=e.target.closest(".na-sel")){ play(t.querySelector(".icn"),"naa-spin"); play(t,"naa-press"); return; }
      if(t=e.target.closest(".na-fsel")){ play(t.querySelector(".icn"),"naa-spin"); play(t,"naa-press"); return; }
      if(t=e.target.closest(".na-search,.na-finput")){ play(t,"naa-glow"); return; }
      if(t=e.target.closest(".na-note.add")){ play(t,"naa-pop"); return; }
      if(t=e.target.closest(".na-day")){ play(t,"naa-press"); play(t.closest(".na-task"),"naa-snooze"); return; }
      if(t=e.target.closest(".na-done")){ play(t,"naa-press"); play(t,"naa-flash"); play(t.querySelector(".icn"),"naa-pop"); return; }
      if(t=e.target.closest(".na-chipf span")){ if(!t.classList.contains("dash")){ t.parentNode.querySelectorAll("span").forEach(function(s){s.classList.remove("on");}); t.classList.add("on"); } play(t,"naa-pop"); return; }
      if(t=e.target.closest(".na-subtabs span")){ t.parentNode.querySelectorAll("span").forEach(function(s){s.classList.remove("on");}); t.classList.add("on"); play(t,"naa-press"); return; }
      if(t=e.target.closest(".na-tag")){ play(t,"naa-pop"); return; }
      if(t=e.target.closest(".na-tab")){ play(t,"naa-press"); return; }
      if(t=e.target.closest(".roi-tab")){ play(t,"naa-press"); return; }
      if(t=e.target.closest(".na-launch,.na-btn,.na-btn2,.na-mini,.na-fu")){ play(t,"naa-press"); iconAnim(t); return; }
    });

    // ROI sub-tabs (By method / playbook / rep / campaign)
    app.querySelectorAll(".roi-tabs").forEach(function(tabs){
      var wrap=tabs.parentNode;
      tabs.querySelectorAll(".roi-tab").forEach(function(tb){
        tb.addEventListener("click",function(){
          tabs.querySelectorAll(".roi-tab").forEach(function(x){x.classList.remove("on");});
          tb.classList.add("on");
          var k=tb.getAttribute("data-rt");
          wrap.querySelectorAll(".roi-panel").forEach(function(pn){ pn.hidden = pn.getAttribute("data-rtp")!==k; });
        });
      });
    });
  });
});

;

(function(){
  document.querySelectorAll('.ds-tabs').forEach(function(tabs){
    var studio = tabs.parentElement;
    tabs.querySelectorAll('.ds-tab').forEach(function(t){
      t.addEventListener('click', function(){
        tabs.querySelectorAll('.ds-tab').forEach(function(x){ x.classList.remove('on'); });
        t.classList.add('on');
        var n = t.getAttribute('data-ds');
        studio.querySelectorAll('.ds-panel').forEach(function(pnl){
          pnl.hidden = (pnl.getAttribute('data-dspanel') !== n);
        });
      });
    });
  });
})();

;

document.addEventListener("DOMContentLoaded",function(){
  var o=document.getElementById("dsOld"), n=document.getElementById("dsNew");
  var demo=document.getElementById("dsDemoBtn"), back=document.getElementById("dsBackBtn");
  if(demo&&o&&n){ demo.addEventListener("click",function(){
      var cur=document.querySelector("#dsOld .ds-tab.on");
      var map={letter:"letter","env-addr":"envaddr","env-brand":"envbrand",box:"box",landing:"landing"};
      var want=cur?(map[cur.getAttribute("data-ds")]||"letter"):"letter";
      o.hidden=true; n.hidden=false;
      var t2=document.querySelector('.ds2-tab[data-dt="'+want+'"]'); if(t2) t2.click();
      n.scrollIntoView({behavior:"smooth",block:"start"});
  }); }
  if(back&&o&&n){ back.addEventListener("click",function(){ n.hidden=true; o.hidden=false; o.scrollIntoView({behavior:"smooth",block:"start"}); }); }
});

;

document.addEventListener("DOMContentLoaded",function(){
  var L=document.getElementById("dsLetter"); if(!L) return;
  var txt=L.querySelector(".ds2-ltxt"); var panel=L.closest(".ds2-p");
  var st={font:"modern",typeface:"Lora",size:3,width:6,across:6,down:2,border:"single",color:"#0a0f1c",thick:3,radius:6,opacity:100};
  function fam(){ return st.font==="robot" ? "'Patrick Hand', cursive" : "'"+st.typeface+"', Georgia, serif"; }
  function rgba(h,a){ h=h.replace("#",""); if(h.length===3)h=h.split("").map(function(c){return c+c;}).join(""); return "rgba("+parseInt(h.substr(0,2),16)+","+parseInt(h.substr(2,2),16)+","+parseInt(h.substr(4,2),16)+","+a+")"; }
  function render(){
    txt.style.fontFamily=fam();
    txt.style.fontSize=(11.5+st.size*1.0)+"px";
    txt.style.maxWidth=(60+st.width*4)+"%";
    txt.style.marginLeft=((st.across-5)*6)+"px";
    txt.style.paddingTop=(st.down*6)+"px";
    var c=document.getElementById("dsChars"); if(c) c.textContent=Math.round(880-st.size*80);
    L.classList.remove("mode-corners");
    if(st.border==="none"){ L.style.border="none"; }
    else if(st.border==="corners"){ L.style.border="none"; L.classList.add("mode-corners"); L.querySelectorAll(".ds2-corner").forEach(function(x){x.style.borderColor=st.color;}); }
    else { L.style.borderStyle=st.border==="double"?"double":"solid"; L.style.borderWidth=(st.border==="double"?Math.max(st.thick,4):st.thick)+"px"; L.style.borderColor=rgba(st.color,st.opacity/100); }
    L.style.borderRadius=st.radius+"px";
  }
  document.querySelectorAll("[data-font]").forEach(function(b){ b.addEventListener("click",function(){ st.font=b.getAttribute("data-font"); render(); }); });
  var tf=document.getElementById("dsTypeface"); if(tf) tf.addEventListener("change",function(){ st.typeface=tf.value; render(); });
  document.querySelectorAll("[data-border]").forEach(function(b){ b.addEventListener("click",function(){ st.border=b.getAttribute("data-border"); render(); }); });
  var col=document.getElementById("dsBorderColor"); if(col) col.addEventListener("input",function(){ st.color=col.value; render(); });
  if(panel) panel.querySelectorAll(".ds2-rng[data-ds2]").forEach(function(r){ r.addEventListener("input",function(){ st[r.getAttribute("data-ds2")]=+r.value; render(); }); });
  render();
});

;

document.addEventListener("DOMContentLoaded",function(){
  var P=document.querySelector('.ds2-p[data-dtp="envaddr"]'); if(!P) return;
  var EV=P.querySelector('.ds2-envelope'); var A=EV.querySelector('.ds2-addr'); var D=EV.querySelector('.ds2-envdeco');
  D.className='ds2-envdeco ea-deco';
  var N="Anne Johnson", L1="6 Pancras Square", L2="London", L3="N1C 4AG";
  function envIcon(x,y,rot,c){ return '<g transform="translate('+x+' '+y+') rotate('+rot+')"><rect x="-11" y="-8" width="22" height="16" rx="2.5" fill="'+c+'"/><path d="M-11 -8 L0 2 L11 -8" fill="none" stroke="#fff" stroke-width="2"/></g>'; }
  function cyc(x,y,c){ return '<g transform="translate('+x+' '+y+')" stroke="'+c+'" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"><circle cx="-8" cy="6" r="5"/><circle cx="8" cy="6" r="5"/><path d="M-8 6 L-2 -4 L6 -4 M-2 -4 L2 6 M2 6 L8 6 M-2 -4 L1 -9 L6 -9"/></g>'; }
  function burst(x,y,c){ return '<g transform="translate('+x+' '+y+')" stroke="'+c+'" stroke-width="2.4" stroke-linecap="round"><path d="M0 -8V-3M0 3V8M-8 0H-3M3 0H8M-5 -5L-2 -2M2 2L5 5M5 -5L2 -2M-2 2L-5 5"/></g>'; }
  function setA(html,css){ A.className='ds2-addr'; A.removeAttribute('style'); A.style.position='absolute'; for(var k in css) A.style[k]=css[k]; A.innerHTML=html; }
  function svg(w,inner){ return '<svg viewBox="0 0 '+w[0]+' '+w[1]+'" style="width:'+w[2]+'px;overflow:visible">'+inner+'</svg>'; }

  var TH={
    "Robot Writing":function(){ setA(N+'<br>'+L1+'<br>'+L2+'<br>'+L3,{left:'54px',top:'50%',transform:'translateY(-50%)',fontFamily:"'Patrick Hand',cursive",color:'#d6336c',fontSize:'30px',lineHeight:'1.4'}); },
    "Typewriter":function(){ setA(N+'<br>'+L1+'<br>'+L2+'<br>'+L3,{left:'54px',top:'50%',transform:'translateY(-50%)',fontFamily:"'Special Elite',monospace",color:'#c0295a',fontSize:'20px',lineHeight:'2.05'}); },
    "Cool Kiwi":function(){
      D.innerHTML='<div style="left:8%;top:34%">'+svg([210,180,150],'<ellipse cx="100" cy="92" rx="72" ry="64" fill="#f3a9c3" stroke="#d6336c" stroke-width="5"/><path d="M168 90 L214 100 L168 112 Z" fill="#f7c2d6" stroke="#d6336c" stroke-width="4" stroke-linejoin="round"/><circle cx="128" cy="74" r="17" fill="#fff" stroke="#d6336c" stroke-width="4"/><circle cx="132" cy="76" r="8.5" fill="#1b2340"/><circle cx="135.5" cy="72" r="2.6" fill="#fff"/><path d="M84 152 L82 172 M82 172 L73 179 M82 172 L91 179" stroke="#d6336c" stroke-width="4.5" fill="none" stroke-linecap="round"/><path d="M112 152 L114 172 M114 172 L105 179 M114 172 L123 179" stroke="#d6336c" stroke-width="4.5" fill="none" stroke-linecap="round"/>')+'</div>';
      setA('<span style="color:#d6336c">'+N+'</span><br>'+L1+'<br>'+L2+'<br>'+L3,{left:'50%',top:'34%',fontFamily:"'Patrick Hand',cursive",color:'#2a2f45',fontSize:'21px',lineHeight:'1.5'});
      A.classList.add('ea-addr','bubble');
    },
    "Twilight Birds":function(){
      D.innerHTML='<div style="left:6%;top:14%">'+svg([300,120,300],
        '<line x1="12" y1="72" x2="205" y2="72" stroke="#d6336c" stroke-width="4"/>'+
        '<g transform="translate(58 52)"><ellipse cx="0" cy="10" rx="20" ry="17" fill="#f3a9c3" stroke="#d6336c" stroke-width="3"/><circle cx="9" cy="4" r="3" fill="#1b2340"/><path d="M18 5 L30 8 L18 12 Z" fill="#f7c2d6" stroke="#d6336c" stroke-width="2"/><path d="M-6 26 V33 M5 26 V33" stroke="#d6336c" stroke-width="2.5"/></g>'+
        '<g transform="translate(120 52)"><ellipse cx="0" cy="10" rx="20" ry="17" fill="#c9ccd6" stroke="#8a91a3" stroke-width="3"/><circle cx="9" cy="4" r="3" fill="#1b2340"/><path d="M18 5 L30 8 L18 12 Z" fill="#dfe2ea" stroke="#8a91a3" stroke-width="2"/><path d="M-6 26 V33 M5 26 V33" stroke="#8a91a3" stroke-width="2.5"/></g>'+
        '<text x="228" y="44" fill="#d6336c" font-size="26">&#9834;</text><text x="250" y="32" fill="#d6336c" font-size="20">&#9835;</text>'+
        '<path d="M258 16 q7 -7 14 0 q7 -7 14 0" fill="none" stroke="#9aa4b2" stroke-width="2.5" stroke-linecap="round"/>')+'</div>';
      setA('<span style="color:#d6336c">'+N+'</span><br>'+L1+'<br>'+L2+'<br>'+L3,{left:'56%',top:'44%',fontFamily:"'Patrick Hand',cursive",color:'#2a2f45',fontSize:'20px',lineHeight:'1.5','--bc':'#d6336c'});
      A.classList.add('ea-addr','bubble','notail');
    },
    "Doodle Cluster":function(){
      var g=''; var cols=['#d6336c','#e8712e','#3f9e57','#c9a227','#2d6cdf'];
      var ps=[[250,118,-12],[312,104,10],[384,128,-6],[266,176,8],[340,172,-10],[412,166,14],[290,226,-8],[372,222,6],[334,264,-4]];
      var inner=''; ps.forEach(function(p,i){ inner+=envIcon(p[0],p[1],p[2],cols[i%5]); });
      D.innerHTML='<svg viewBox="0 0 560 350" style="width:100%;height:100%">'+inner+'</svg>';
      setA('<div style="font-family:\'Fredoka\',sans-serif;font-weight:700;color:#c62a70;font-size:30px;line-height:1.05;margin-bottom:8px">Anne<br>Johnson</div><div style="font-family:\'Patrick Hand\',cursive;color:#2a2f45;font-size:20px;line-height:1.5">'+L1+'<br>'+L2+'<br>'+L3+'</div>',{left:'44px',top:'50%',transform:'translateY(-50%)'});
    },
    "Stamp & Rule":function(){
      setA('<div style="font-family:\'Special Elite\',monospace;color:#1b2340;font-size:24px;letter-spacing:1px">ANNE JOHNSON</div><svg viewBox="0 0 200 16" style="width:200px;margin:2px 0 10px"><path d="M4 10 Q40 0 78 8 T156 8" fill="none" stroke="#d6336c" stroke-width="3" stroke-linecap="round"/></svg><div style="font-family:\'Special Elite\',monospace;color:#1b2340;font-size:16px;letter-spacing:1px;line-height:1.9">6 PANCRAS SQUARE<br>LONDON &middot; N1C 4AG</div>',{left:'54px',top:'50%',transform:'translateY(-50%)'});
    },
    "Hand-Lettered Pop":function(){
      D.innerHTML='<div style="right:34%;top:22%">'+svg([40,40,42],burst(20,20,'#3f9e57'))+'</div><div style="right:16%;top:40%">'+svg([40,40,42],burst(20,20,'#c9a227'))+'</div><div style="right:26%;top:64%">'+svg([40,40,42],burst(20,20,'#d6336c'))+'</div>';
      setA('<div style="font-family:\'Caveat\',cursive;font-weight:700;color:#d6336c;font-size:34px;line-height:1">Anne</div><div style="font-family:\'Permanent Marker\',cursive;color:#3f9e57;font-size:26px;line-height:1.1">JOHNSON</div><div style="font-family:\'Caveat\',cursive;font-weight:700;color:#c9a227;font-size:26px;line-height:1.2">6 Pancras Square</div><div style="font-family:\'Permanent Marker\',cursive;color:#d6336c;font-size:20px;line-height:1.3">LONDON</div><div style="margin-top:4px"><span class="ea-hi" style="font-family:\'Permanent Marker\',cursive;font-size:18px">N1C 4AG</span></div>',{left:'50px',top:'50%',transform:'translateY(-50%)'});
    },
    "Top Secret":function(){
      D.innerHTML='<div class="ea-ts">TOP SECRET</div>';
      setA('<div class="ea-ref">FILE REF &middot; DELIVER TO</div><div style="font-family:\'Special Elite\',monospace;color:#1b2340;font-size:22px;font-weight:700;letter-spacing:1px">ANNE JOHNSON</div><div style="font-family:\'Special Elite\',monospace;color:#1b2340;font-size:15px;letter-spacing:1px;line-height:1.9;margin-top:6px">6 PANCRAS SQUARE<br>LONDON &middot; N1C 4AG</div>',{left:'42px',top:'46%'});
    },
    "Creative":function(){
      EV.classList.add('creative');
      var g=''; var cs=['#d6336c','#2d6cdf','#6d28d9']; var ps=[[70,55],[200,48],[330,52],[420,72],[500,142],[468,190],[522,226],[110,292],[250,302],[366,298],[462,286]];
      var inner=''; ps.forEach(function(p,i){ inner+=cyc(p[0],p[1],cs[i%3]); });
      D.innerHTML='<svg viewBox="0 0 560 350" style="width:100%;height:100%">'+inner+'</svg>';
      setA('<span style="color:#6d28d9;font-weight:700">'+N+'</span><br>'+L1+'<br>'+L2+'<br>'+L3,{left:'26%',top:'50%',transform:'translateY(-50%)',fontFamily:"'Patrick Hand',cursive",color:'#2a2f45',fontSize:'20px',lineHeight:'1.5','--bc':'#6d28d9'});
      A.classList.add('ea-addr','bubble','notail'); A.style.borderColor='#6d28d9';
    }
  };
  function apply(name){ EV.classList.remove('creative'); D.innerHTML=''; (TH[name]||TH["Robot Writing"])(); }
  // ---- live Font / Line spacing / drag / resize on the address ----
  var eaState={mode:'robot',font:"'Patrick Hand', cursive",lh:'1.35'}, eaTouched=false, eaScale=1;
  function eaFam(){ return eaState.mode==='modern' ? "'Inter', system-ui, sans-serif" : eaState.font; }
  function applyEaStyle(){
    var fam=eaFam(), lh=eaState.lh;
    A.style.fontFamily=fam; A.style.lineHeight=lh;
    A.querySelectorAll('*').forEach(function(e){ if(e.className!=='ea-resize'){ e.style.fontFamily=fam; e.style.lineHeight=lh; } });
  }
  var RESIZE_SVG='<svg viewBox="0 0 24 24"><path d="M7 17L17 7"/><path d="M17 12V7H12"/><path d="M7 12v5h5"/></svg>';
  var STG=EV.querySelector('.ea-stage'), eaTx=0, eaTy=0;
  function stageRender(){ if(!STG) return; STG.style.transformOrigin='center'; STG.style.transform='translate('+eaTx+'px,'+eaTy+'px) scale('+eaScale+')'; }
  function ensureHandle(){ if(STG&&!STG.querySelector('.ea-resize')){ var h=document.createElement('span'); h.className='ea-resize'; h.innerHTML=RESIZE_SVG; STG.appendChild(h); } }
  var _apply=apply;
  apply=function(name){ eaScale=1; eaTx=0; eaTy=0; _apply(name); if(STG) STG.style.transform=''; ensureHandle(); if(eaTouched) applyEaStyle(); };
  var fontSel=document.getElementById('eaFont'), spRng=document.getElementById('eaSpacing'), spVal=document.getElementById('eaSpacingVal'), mode=document.getElementById('eaMode');
  if(fontSel) fontSel.addEventListener('change',function(){ eaState.mode='robot'; eaState.font="'"+this.value+"', cursive"; if(mode){ mode.querySelectorAll('.ds2-segbtn').forEach(function(b){ b.classList.toggle('on',b.getAttribute('data-eamode')==='robot'); }); } eaTouched=true; applyEaStyle(); });
  if(spRng) spRng.addEventListener('input',function(){ eaState.lh=(this.value/100).toFixed(2); if(spVal) spVal.textContent=eaState.lh; eaTouched=true; applyEaStyle(); });
  if(mode) mode.querySelectorAll('.ds2-segbtn').forEach(function(b){ b.addEventListener('click',function(){ mode.querySelectorAll('.ds2-segbtn').forEach(function(x){x.classList.remove('on');}); b.classList.add('on'); eaState.mode=b.getAttribute('data-eamode'); eaTouched=true; applyEaStyle(); }); });
  // drag anywhere to move the whole design, corner to resize the whole design
  var drag=null;
  EV.addEventListener('mousedown',function(e){
    if(!STG) return; var handle=e.target.closest('.ea-resize'); var inStage=STG.contains(e.target);
    if(!inStage&&!handle) return; e.preventDefault();
    if(handle){ drag={mode:'resize',sx:e.clientX,base:eaScale}; }
    else { drag={mode:'move',sx:e.clientX,sy:e.clientY,ox:eaTx,oy:eaTy}; }
  });
  document.addEventListener('mousemove',function(e){
    if(!drag) return;
    if(drag.mode==='move'){ eaTx=drag.ox+(e.clientX-drag.sx); eaTy=drag.oy+(e.clientY-drag.sy); stageRender(); }
    else { eaScale=Math.max(0.5,Math.min(2.2, drag.base+(e.clientX-drag.sx)*0.006)); stageRender(); }
  });
  document.addEventListener('mouseup',function(){ drag=null; });

  P.querySelectorAll('.ds2-theme').forEach(function(t){ t.addEventListener('click',function(){ apply(t.querySelector('b').textContent.trim()); }); });
  apply("Robot Writing");
});

;

document.addEventListener("DOMContentLoaded",function(){
  var P=document.querySelector('.ds2-p[data-dtp="envbrand"]'); if(!P) return;
  var B=P.querySelector('.ds2-branded'); if(!B) return;
  var G="#2e9e82", D="#26314f";
  function star(x,y,r,c){ return '<path d="M'+x+' '+(y-r)+' L'+(x+r*0.28)+' '+(y-r*0.28)+' L'+(x+r)+' '+y+' L'+(x+r*0.28)+' '+(y+r*0.28)+' L'+x+' '+(y+r)+' L'+(x-r*0.28)+' '+(y+r*0.28)+' L'+(x-r)+' '+y+' L'+(x-r*0.28)+' '+(y-r*0.28)+' Z" fill="'+c+'"/>'; }
  function dot(x,y,r,c){ return '<circle cx="'+x+'" cy="'+y+'" r="'+r+'" fill="'+c+'"/>'; }
  function smiley(x,y,c){ return '<g transform="translate('+x+' '+y+')" stroke="'+c+'" stroke-width="2.2" fill="none" stroke-linecap="round"><circle cx="0" cy="0" r="10"/><circle cx="-4" cy="-2.5" r="1" fill="'+c+'" stroke="none"/><circle cx="4" cy="-2.5" r="1" fill="'+c+'" stroke="none"/><path d="M-4.5 3 Q0 7 4.5 3"/></g>'; }
  function rect(x,y,rot,c){ return '<rect x="'+x+'" y="'+y+'" width="10" height="4" rx="1.5" fill="'+c+'" transform="rotate('+rot+' '+x+' '+y+')"/>'; }
  function deco(inner){ return '<div class="eb-deco"><svg viewBox="0 0 560 350" style="width:100%;height:100%">'+inner+'</svg></div>'; }
  function wrap(html){ return '<div class="eb-wrap">'+html+'</div>'; }
  var W="A little something for you", FOR='<div style="font-family:\'Kalam\',cursive;font-style:italic;color:'+G+';font-size:22px;margin-top:14px">For Anne</div>';

  var TH={
    "Name Only":function(){ return wrap('<div style="font-family:\'Fredoka\',sans-serif;font-weight:700;font-style:italic;color:'+G+';font-size:56px">Anne</div>'); },
    "Open Me":function(){ return wrap('<div style="font-family:\'Fredoka\',sans-serif;font-weight:700;color:'+G+';font-size:46px">Open me!</div><div style="font-family:\'Patrick Hand\',cursive;color:'+D+';font-size:24px;margin-top:12px">For Anne</div>'); },
    "Kiwi Hello":function(){
      var kiwi='<svg viewBox="0 0 210 175" style="width:150px;flex:none"><ellipse cx="98" cy="90" rx="66" ry="58" fill="#dbeee7" stroke="'+G+'" stroke-width="4.5"/><path d="M160 88 L208 98 L160 108 Z" fill="#c9e6dc" stroke="'+G+'" stroke-width="3.5" stroke-linejoin="round"/><circle cx="124" cy="74" r="14" fill="#fff" stroke="'+G+'" stroke-width="3.5"/><circle cx="127" cy="76" r="7" fill="#1b2340"/><circle cx="130" cy="72.5" r="2.2" fill="#fff"/><path d="M50 58 q-16 -8 -24 3" fill="none" stroke="'+G+'" stroke-width="3.5" stroke-linecap="round"/><path d="M82 146 L80 164 M80 164 L72 170 M80 164 L88 170" stroke="'+G+'" stroke-width="4" fill="none" stroke-linecap="round"/><path d="M110 146 L112 164 M112 164 L104 170 M112 164 L120 170" stroke="'+G+'" stroke-width="4" fill="none" stroke-linecap="round"/></svg>';
      return '<div style="position:absolute;inset:0;display:flex;align-items:center;justify-content:center;gap:6px;padding:20px">'+kiwi+'<div class="eb-bubble"><div style="font-family:\'Kalam\',cursive;font-weight:700;color:'+G+';font-size:22px">Hi Anne!</div><div style="font-family:\'Patrick Hand\',cursive;color:'+D+';font-size:20px;margin-top:4px">A little something for you</div></div></div>';
    },
    "Confetti Pop":function(){
      var cs=['#d6336c','#e8712e','#3f9e57','#c9a227','#2d6cdf'], inner='';
      var pts=[[80,50,20],[200,42,-30],[360,48,40],[490,58,10],[110,105,-15],[470,110,25],[55,175,-40],[520,175,15],[95,250,-20],[250,300,35],[400,305,-10],[500,265,20],[150,300,-30],[380,55,15]];
      pts.forEach(function(p,i){ inner+= (i%2? dot(p[0],p[1],3.5,cs[i%5]) : rect(p[0],p[1],p[2],cs[i%5])); });
      return deco(inner)+wrap('<div style="font-family:\'Permanent Marker\',cursive;color:'+G+';font-size:36px">SURPRISE INSIDE!</div><div style="font-family:\'Patrick Hand\',cursive;color:'+D+';font-size:24px;margin-top:12px">For Anne</div>');
    },
    "Banner Birds":function(){
      var birds='<svg viewBox="0 0 180 44" style="position:absolute;top:-24px;left:50%;transform:translateX(-50%);width:170px"><g transform="translate(40 22)"><ellipse cx="0" cy="0" rx="17" ry="15" fill="#dbeee7" stroke="'+G+'" stroke-width="2.5"/><circle cx="8" cy="-2" r="2.6" fill="#1b2340"/><path d="M16 -1 L26 1 L16 4 Z" fill="'+G+'"/></g><g transform="translate(140 22)"><ellipse cx="0" cy="0" rx="17" ry="15" fill="#dbeee7" stroke="'+G+'" stroke-width="2.5"/><circle cx="-8" cy="-2" r="2.6" fill="#1b2340"/><path d="M-16 -1 L-26 1 L-16 4 Z" fill="'+G+'"/></g></svg>';
      return wrap('<div style="position:relative;display:inline-block">'+birds+'<div style="background:'+G+';border-radius:14px;padding:24px 40px;color:#fff;font-family:\'Caveat\',cursive;font-weight:700;font-style:italic;font-size:30px">A little something for you</div></div><div style="font-family:\'Patrick Hand\',cursive;color:'+D+';font-size:22px;margin-top:18px">For Anne</div>');
    },
    "Brand Crest":function(){
      return wrap('<div style="display:inline-flex;flex-direction:column;align-items:center;justify-content:center;width:130px;height:130px;border:2px solid '+G+';border-radius:50%;margin-bottom:18px"><div style="width:46px;height:46px;border-radius:13px;background:'+G+';display:flex;align-items:center;justify-content:center"><svg viewBox="0 0 32 32" style="width:26px;height:26px"><path d="M16 4C10 9 8 15 10 21C11.5 25 14.5 27 16 27.5C17.5 27 20.5 25 22 21C24 15 22 9 16 4Z" fill="#fff"/></svg></div><div style="font-size:10px;letter-spacing:2.5px;color:#9aa4b2;margin-top:9px;font-weight:700">NORTHWIND</div></div><div style="font-family:\'Patrick Hand\',cursive;color:'+D+';font-size:25px">A little something for you</div>'+FOR);
    },
    "Sparkle":function(){
      var inner=''; var sc=['#2d6cdf','#2e9e82','#c9a227'];
      var sp=[[120,70],[190,110],[430,90],[500,150],[350,300],[470,300],[140,290],[240,320]];
      sp.forEach(function(p,i){ inner+=star(p[0],p[1],7,sc[i%3]); });
      [[90,120,'#2d6cdf'],[300,80,'#2e9e82'],[210,300,'#c9a227'],[420,210,'#2e9e82'],[160,200,'#2d6cdf']].forEach(function(p){ inner+=dot(p[0],p[1],3,p[2]); });
      return deco(inner)+wrap('<div style="font-family:\'Patrick Hand\',cursive;color:'+D+';font-size:27px">A little something for you</div>'+FOR);
    },
    "Free Text":function(){
      return wrap('<div style="font-family:\'Patrick Hand\',cursive;color:'+D+';font-size:27px;line-height:1.3;max-width:70%">A little something to brighten your day</div><svg viewBox="0 0 200 16" style="width:200px;margin:8px 0"><path d="M6 10 Q46 0 86 8 T176 8" fill="none" stroke="'+G+'" stroke-width="3" stroke-linecap="round"/></svg><div style="font-family:\'Kalam\',cursive;font-style:italic;color:'+G+';font-size:22px">For Anne</div>');
    },
    "Creative":function(){
      var cs=['#2d6cdf','#2e9e82','#26314f'], inner='';
      [[95,60],[300,52],[470,66],[150,110],[440,120],[60,185],[505,185],[110,295],[320,300],[470,290]].forEach(function(p,i){ inner+=smiley(p[0],p[1],cs[i%3]); });
      return deco(inner)+wrap('<div style="font-family:\'Kalam\',cursive;font-weight:700;color:'+G+';font-size:30px">A little something for you</div><div style="font-family:\'Patrick Hand\',cursive;color:'+D+';font-size:22px;margin-top:12px">For Anne</div>');
    }
  };
  function apply(name){ B.innerHTML=(TH[name]||TH["Sparkle"])(); }
  // ---- move + resize the COMPLETE branded design (deco + content together) ----
  var ebScale=1, ebTx=0, ebTy=0;
  var EB_RSVG='<svg viewBox="0 0 24 24"><path d="M7 17L17 7"/><path d="M17 12V7H12"/><path d="M7 12v5h5"/></svg>';
  function ebStage(){ return B.querySelector('.eb-stage'); }
  function ebWrapStage(){
    var stg=document.createElement('div'); stg.className='eb-stage';
    var kids=[]; for(var i=0;i<B.children.length;i++) kids.push(B.children[i]);
    kids.forEach(function(k){ stg.appendChild(k); });
    B.appendChild(stg);
    var h=document.createElement('span'); h.className='eb-resize'; h.innerHTML=EB_RSVG; stg.appendChild(h);
    return stg;
  }
  function ebRender(){ var s=ebStage(); if(!s) return; s.style.transformOrigin='center'; s.style.transform='translate('+ebTx+'px,'+ebTy+'px) scale('+ebScale+')'; }
  var _applyB=apply;
  apply=function(n){ ebScale=1; ebTx=0; ebTy=0; _applyB(n); ebWrapStage(); };
  var edrag=null;
  B.addEventListener('mousedown',function(e){
    var s=ebStage(); if(!s) return; var handle=e.target.closest('.eb-resize');
    if(!s.contains(e.target)&&!handle) return; e.preventDefault();
    if(handle){ edrag={mode:'resize',sx:e.clientX,base:ebScale}; }
    else { edrag={mode:'move',sx:e.clientX,sy:e.clientY,ox:ebTx,oy:ebTy}; }
  });
  document.addEventListener('mousemove',function(e){
    if(!edrag) return;
    if(edrag.mode==='move'){ ebTx=edrag.ox+(e.clientX-edrag.sx); ebTy=edrag.oy+(e.clientY-edrag.sy); ebRender(); }
    else { ebScale=Math.max(0.5,Math.min(2, edrag.base+(e.clientX-edrag.sx)*0.005)); ebRender(); }
  });
  document.addEventListener('mouseup',function(){ edrag=null; });
  P.querySelectorAll('.ds2-theme').forEach(function(t){ t.addEventListener('click',function(){ apply(t.querySelector('b').textContent.trim()); }); });
  apply("Sparkle");
});

;

document.addEventListener("DOMContentLoaded",function(){
  var P=document.querySelector('.ds2-p[data-dtp="box"]'); if(!P) return;
  var slotsEl=document.getElementById('boxSlots'), thumbsEl=document.getElementById('boxThumbs');
  var activeEl=document.getElementById('boxActive'), capEl=document.getElementById('boxCaption');
  if(!slotsEl) return;
  var LIB={
    coffee:'<path d="M13 20h18v9a7 7 0 0 1-7 7h-4a7 7 0 0 1-7-7z"/><path d="M31 22h4a4 4 0 0 1 0 8h-4"/><path d="M18 11c2 2 0 4 0 6M24 11c2 2 0 4 0 6"/>',
    bean:'<ellipse cx="24" cy="24" rx="8" ry="12"/><path d="M21 14c3 6 3 14 0 20"/>',
    bottle:'<path d="M21 10h6v6l2 4v16a2 2 0 0 1-2 2h-6a2 2 0 0 1-2-2V20l2-4z"/><path d="M21 16h6"/>',
    flag:'<path d="M23 11l12 4.5-12 4.5z"/><path d="M23 11v22"/><ellipse cx="23" cy="34" rx="8" ry="2.8"/>',
    gball:'<circle cx="24" cy="24" r="11"/><circle cx="20" cy="21" r="1.2" fill="#3a3122"/><circle cx="27" cy="20" r="1.2" fill="#3a3122"/><circle cx="24" cy="26" r="1.2" fill="#3a3122"/><circle cx="29" cy="26" r="1.2" fill="#3a3122"/>',
    trophy:'<path d="M18 12h12v7a6 6 0 0 1-12 0z"/><path d="M18 15h-4a4 4 0 0 0 4 4M30 15h4a4 4 0 0 1-4 4"/><path d="M24 25v5M20 34h8M22 30h4v4h-4z"/>',
    wine:'<path d="M16 12h16l-2 10a6 6 0 0 1-12 0z"/><path d="M24 28v8M18 36h12"/>',
    grapes:'<circle cx="20" cy="26" r="4"/><circle cx="28" cy="26" r="4"/><circle cx="24" cy="32" r="4"/><path d="M24 22v-6c3 0 6-2 7-4"/>',
    shoe:'<path d="M9 30h7l4-6 3 4 9 2 5 4v4H9z"/><path d="M20 24l2 2M24 26l2 2"/>',
    medal:'<circle cx="24" cy="30" r="8"/><path d="M20 22l-4-10M28 22l4-10"/><path d="M24 27l1.3 2.6 2.7.4-2 1.9.5 2.7-2.5-1.3-2.5 1.3.5-2.7-2-1.9 2.7-.4z"/>',
    bike:'<circle cx="15" cy="31" r="7"/><circle cx="33" cy="31" r="7"/><path d="M15 31l7-12h7M22 19l7 12M22 19h-3M29 19l4 12"/>',
    dog:'<path d="M17 15C11 16 10 25 15 30"/><path d="M31 15C37 16 38 25 33 30"/><path d="M17 15C19 11 29 11 31 15C33 20 33 25 30 29C28 33 25 35 24 35C23 35 20 33 18 29C15 25 15 20 17 15Z"/><circle cx="20" cy="23" r="1.5" fill="#3a3122" stroke="none"/><circle cx="28" cy="23" r="1.5" fill="#3a3122" stroke="none"/><path d="M21.5 28.5h5l-2.5 3.2z" fill="#3a3122" stroke="none"/><path d="M24 31.7v2"/>',
    paw:'<circle cx="24" cy="31" r="6"/><circle cx="16" cy="23" r="2.6"/><circle cx="21" cy="18" r="2.6"/><circle cx="27" cy="18" r="2.6"/><circle cx="32" cy="23" r="2.6"/>',
    bone:'<circle cx="16" cy="19" r="3.6"/><circle cx="20" cy="23" r="3.6"/><circle cx="32" cy="29" r="3.6"/><circle cx="28" cy="33" r="3.6"/><path d="M19 22l10 9"/>',
    plane:'<path d="M24 8l3.5 13L40 27l-12.5 1.5L24 40l-3.5-11.5L8 27l12.5-6z"/>',
    suitcase:'<rect x="13" y="20" width="22" height="16" rx="2"/><path d="M20 20v-4h8v4M24 20v16"/>',
    globe:'<circle cx="24" cy="24" r="12"/><path d="M12 24h24M24 12v24M16 16c8 6 8 10 0 16M32 16c-8 6-8 10 0 16"/>',
    book:'<path d="M14 14h15a3 3 0 0 1 3 3v17a3 3 0 0 0-3-3H14z"/><path d="M14 14v17"/>',
    bookmark:'<path d="M18 12h12v24l-6-5-6 5z"/>',
    pencil:'<path d="M14 34l2-6 13-13 4 4-13 13z"/><path d="M27 17l4 4"/>',
    note:'<path d="M19 34a4 4 0 1 1-4-4 4 4 0 0 1 4 4V16l13-3v14"/><path d="M32 27a4 4 0 1 1-4-4 4 4 0 0 1 4 4"/>',
    headphones:'<path d="M14 28v-4a10 10 0 0 1 20 0v4"/><rect x="11" y="28" width="6" height="9" rx="2"/><rect x="31" y="28" width="6" height="9" rx="2"/>',
    guitar:'<circle cx="20" cy="30" r="8"/><circle cx="20" cy="30" r="3"/><path d="M25 25l9-10 3 3-10 9"/>',
    dumbbell:'<path d="M10 24h28M14 18v12M11 21v6M34 18v12M37 21v6"/>',
    whisky:'<path d="M16 15h16v18a2 2 0 0 1-2 2H18a2 2 0 0 1-2-2z"/><path d="M16 26h16"/><rect x="20" y="28" width="4" height="4" rx="1" fill="#3a3122" stroke="none"/>',
    barrel:'<ellipse cx="24" cy="15" rx="8" ry="3"/><path d="M16 15v18c0 2 4 3 8 3s8-1 8-3V15"/><path d="M15 24h18"/>',
    football:'<circle cx="24" cy="24" r="11"/><path d="M24 18l5 4-2 6h-6l-2-6z"/><path d="M24 13v5M13.5 22l5 2M34.5 22l-5 2M18 33l2-5M30 33l-2-5"/>',
    goal:'<rect x="12" y="18" width="24" height="15"/><path d="M18 18v15M24 18v15M30 18v15M12 24h24M12 29h24"/>',
    bird:'<circle cx="23" cy="25" r="11"/><path d="M33 20l8-2-4 4z"/><path d="M34 25l8-1-3 4z"/><path d="M33 30l7 3-1-4z"/><path d="M19 14l1.6 3.6"/><path d="M24 12.6l.1 3.9"/><path d="M15 17l6.5 2.6"/><path d="M31.5 17l-6.5 2.6"/><circle cx="20.6" cy="23" r="2.5"/><circle cx="26" cy="23" r="2.5"/><circle cx="21.3" cy="23.6" r="1" fill="#3a3122" stroke="none"/><circle cx="26.7" cy="23.6" r="1" fill="#3a3122" stroke="none"/><path d="M20.5 28h6l-3 3.4z"/><path d="M16.5 32.5c3 2 11.5 2 13.5-.3"/>',
    ball:'<g transform="rotate(-32 24 24)"><path d="M9 24C14 13 34 13 39 24C34 35 14 35 9 24Z"/><path d="M13 21C11 22.5 11 25.5 13 27"/><path d="M35 21C37 22.5 37 25.5 35 27"/><path d="M17.5 24H30.5"/><path d="M20 22V26M23.5 21.2V26.8M27 21.2V26.8M30 22V26"/></g>'
  };
  var LAB={coffee:'coffee',bean:'coffee-bean',bottle:'bottle',flag:'golf',gball:'golf-ball',trophy:'trophy',wine:'wine',grapes:'grapes',shoe:'running-shoe',medal:'medal',bike:'bicycle',dog:'dog',paw:'paw',bone:'bone',plane:'plane',suitcase:'suitcase',globe:'globe',book:'book',bookmark:'bookmark',pencil:'pencil',note:'music-note',headphones:'headphones',guitar:'guitar',dumbbell:'dumbbell',whisky:'whisky',barrel:'barrel',football:'football',goal:'goal',bird:'angry-bird',ball:'football'};
  var TH={Coffee:['coffee','bean','bottle'],Golf:['flag','gball','trophy'],Wine:['wine','bottle','grapes'],Running:['shoe','medal','trophy'],Cycling:['bike','medal','trophy'],Dog:['dog','paw','bone'],Travel:['plane','suitcase','globe'],Books:['book','bookmark','pencil'],Music:['note','headphones','guitar'],Gym:['dumbbell','medal','trophy'],Whisky:['whisky','bottle','barrel'],Football:['football','goal','trophy']};
  var active="Dog";
  var model=[{key:'ball',locked:true}];
  function ico(k){ return '<svg viewBox="0 0 48 48" fill="none" stroke="#3a3122" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">'+(LIB[k]||'')+'</svg>'; }
  function pick(){ var p=TH[active]; return p[Math.floor(Math.random()*p.length)]; }
  function render(){
    slotsEl.innerHTML=model.map(function(m,i){
      if(m.empty) return '<div class="ds2-slot empty" data-i="'+i+'"></div>';
      return '<div class="ds2-slot" data-i="'+i+'"><span class="ds2-lock'+(m.locked?' on':'')+'" data-i="'+i+'" data-act="lock">&#10003;</span>'+ico(m.key)+'</div>';
    }).join('');
    if(thumbsEl) thumbsEl.innerHTML=model.map(function(m){
      return '<div class="ds2-iconcell"><div class="ds2-iconthumb">'+(m.empty?'':ico(m.key))+'</div><div class="ds2-iconsearch">Search this icon&hellip;</div></div>';
    }).join('');
    if(activeEl) activeEl.textContent=active;
    if(capEl) capEl.textContent=model.filter(function(m){return !m.empty;}).map(function(m){return LAB[m.key];}).join(' · ');
  }
  function rerollUnlocked(){ var pool=TH[active].slice(); for(var k=pool.length-1;k>0;k--){var r=Math.floor(Math.random()*(k+1));var t=pool[k];pool[k]=pool[r];pool[r]=t;} var used=model.filter(function(m){return m.locked&&!m.empty;}).map(function(m){return m.key;}); var avail=pool.filter(function(k){return used.indexOf(k)<0;}); if(!avail.length)avail=pool; var idx=0; model.forEach(function(m){ if(!m.locked){ m.empty=false; m.key=avail[idx++ % avail.length]; } }); render(); }
  render();
  // chips
  P.querySelectorAll('.ds2-chip').forEach(function(c){
    c.addEventListener('click',function(){
      P.querySelectorAll('.ds2-chip').forEach(function(x){x.classList.remove('on');}); c.classList.add('on');
      c.classList.remove('pop'); void c.offsetWidth; c.classList.add('pop');
      active=c.textContent.trim(); if(activeEl) activeEl.textContent=active;
    });
  });
  // reimagine / reset -- icon is fixed (the Northwind bird), so these just re-affirm it
  P.querySelectorAll('.ds2-reimagine').forEach(function(b){ b.addEventListener('click',function(){ model=[{key:'ball',locked:true}]; render(); }); });
  P.querySelectorAll('.ds2-reset').forEach(function(b){ b.addEventListener('click',function(){ model=[{key:'ball',locked:true}]; render(); }); });
  // lock / remove / add (delegated on slots)
  slotsEl.addEventListener('click',function(e){
    var t=e.target.closest('[data-act]'); if(!t) return; var i=+t.getAttribute('data-i'); var act=t.getAttribute('data-act');
    if(act==='lock'){ model[i].locked=!model[i].locked; }
    else if(act==='remove'){ model[i].empty=true; model[i].locked=false; }
    else if(act==='add'){ model[i].empty=false; model[i].key=pick(); }
    render();
  });
  // set Dog chip active on load
  P.querySelectorAll('.ds2-chip').forEach(function(c){ if(c.textContent.trim()==='Dog') c.classList.add('on'); });
});

;

/* interactive-demo bubble: pops and dismisses on click */
(function(){
  var b=document.getElementById('liveBubble'); if(!b) return;
  b.addEventListener('click',function(){
    if(b.classList.contains('pop')) return;
    var r=b.getBoundingClientRect(), cx=r.left+r.width/2, cy=r.top+r.height/2;
    var cols=['#1e72b8','#2e9e82','#ffffff','#7cc4f0','#ffd166'];
    for(var i=0;i<14;i++){
      var p=document.createElement('span'); p.className='lb-bit';
      var ang=(Math.PI*2*i/14)+ (i%2?0.3:0), dist=46+ (i%3)*16;
      p.style.left=cx+'px'; p.style.top=cy+'px';
      p.style.background=cols[i%cols.length];
      p.style.setProperty('--bx',(Math.cos(ang)*dist).toFixed(0)+'px');
      p.style.setProperty('--by',(Math.sin(ang)*dist).toFixed(0)+'px');
      document.body.appendChild(p);
      p.addEventListener('animationend',function(){ this.remove(); });
    }
    b.classList.add('pop');
    b.addEventListener('animationend',function(){ b.remove(); });
  });
})();
/* ROI guarantee shield: colourful + interactive */
(function(){
  var s=document.querySelector('.roi-shield'); if(!s) return;
  function burst(){
    s.classList.remove('pop','shine'); void s.offsetWidth; s.classList.add('pop','shine');
    var r=s.getBoundingClientRect(), cx=r.left+r.width/2, cy=r.top+r.height/2;
    var cols=['#3b82f6','#8b5cf6','#ec4899','#f59e0b','#22c55e'];
    for(var i=0;i<10;i++){
      var p=document.createElement('span'); p.className='roi-sh-bit';
      var a=Math.PI*2*i/10, d=30+(i%3)*10;
      p.style.left=(cx-3)+'px'; p.style.top=(cy-3)+'px'; p.style.position='fixed';
      p.style.background=cols[i%cols.length];
      p.style.setProperty('--bx',(Math.cos(a)*d).toFixed(0)+'px');
      p.style.setProperty('--by',(Math.sin(a)*d).toFixed(0)+'px');
      document.body.appendChild(p); p.addEventListener('animationend',function(){this.remove();});
    }
  }
  s.addEventListener('click',burst);
  s.addEventListener('keydown',function(e){ if(e.key==='Enter'||e.key===' '){ e.preventDefault(); burst(); } });
})();
/* inspiration button: lightbulb idea burst */
(function(){
  document.querySelectorAll('.glf-insp').forEach(function(btn){
    var bulb=btn.querySelector('.glf-bulb');
    btn.addEventListener('click',function(){
      btn.classList.remove('idea'); void btn.offsetWidth; btn.classList.add('idea');
      var bx=bulb?bulb.offsetLeft+bulb.offsetWidth/2:12, by=bulb?bulb.offsetTop+bulb.offsetHeight/2:12;
      for(var i=0;i<7;i++){
        var r=document.createElement('span'); r.className='glf-ray';
        r.style.left=bx+'px'; r.style.top=(by-16)+'px';
        r.style.setProperty('--a',(i*(360/7))+'deg');
        btn.appendChild(r); r.addEventListener('animationend',function(){this.remove();});
      }
      ['✨','💡','✨'].forEach(function(ch,i){
        var sp=document.createElement('span'); sp.className='glf-spark'; sp.textContent=ch;
        sp.style.left=bx+'px'; sp.style.top=by+'px';
        sp.style.setProperty('--sx',((i-1)*20)+'px'); sp.style.setProperty('--sy',(-20-i*6)+'px');
        btn.appendChild(sp); sp.addEventListener('animationend',function(){this.remove();});
      });
    });
  });
})();
/* interactive hero stats */
(function(){
  var stats=document.querySelectorAll('.istat'); if(!stats.length) return;
  function planes(el){
    var r=el.getBoundingClientRect();
    for(var i=0;i<6;i++){
      var p=document.createElement('span'); p.className='istat-plane'; p.textContent='✉️';
      p.style.left=(r.width*0.5)+'px'; p.style.top='34px';
      p.style.setProperty('--px',((i-2.5)*26).toFixed(0)+'px');
      p.style.setProperty('--py',(-40-(i%3)*14)+'px');
      p.style.setProperty('--pr',((i-2.5)*18).toFixed(0)+'deg');
      el.appendChild(p); p.addEventListener('animationend',function(){this.remove();});
    }
  }
  function go(el){ el.classList.remove('go'); void el.offsetWidth; el.classList.add('go'); if(el.getAttribute('data-kind')==='mail') planes(el); }
  function clickFx(el){
    go(el);
    var num=el.querySelector('.num'); if(num){ num.classList.remove('pop'); void num.offsetWidth; num.classList.add('pop'); }
    var kind=el.getAttribute('data-kind'), vis=el.querySelector('.istat-vis'); if(!vis) return;
    var vr=vis.getBoundingClientRect(), er=el.getBoundingClientRect();
    var cx=vr.left+vr.width/2-er.left, cy=vr.top+vr.height/2-er.top;
    if(kind==='ring'){ var rp=document.createElement('span'); rp.className='istat-ripple'; rp.style.left=cx+'px'; rp.style.top=cy+'px'; rp.style.width='42px'; rp.style.height='42px'; el.appendChild(rp); rp.addEventListener('animationend',function(){this.remove();}); }
    if(kind==='ring'||kind==='bars'){
      var cols= kind==='ring'?['#ffd166','#ffffff','#7cc4f0']:['#9fd0f2','#4a90c9','#7ee0a6','#ffffff'];
      for(var i=0;i<9;i++){ var d=document.createElement('span'); d.className='istat-dot'; var a=Math.PI*2*i/9+0.4, dist=26+(i%3)*11; d.style.left=cx+'px'; d.style.top=cy+'px'; d.style.background=cols[i%cols.length]; d.style.setProperty('--dx',(Math.cos(a)*dist).toFixed(0)+'px'); d.style.setProperty('--dy',(Math.sin(a)*dist).toFixed(0)+'px'); el.appendChild(d); d.addEventListener('animationend',function(){this.remove();}); }
    }
  }
  var io=new IntersectionObserver(function(en){ en.forEach(function(e){ if(e.isIntersecting){ go(e.target); io.unobserve(e.target); } }); },{threshold:.5});
  stats.forEach(function(el){ io.observe(el); el.addEventListener('click',function(){ clickFx(el); }); });
})();
/* interactive proof stats (83 / 99 / 100) */
(function(){
  var proofs=document.querySelectorAll('.proof[data-pkind]'); if(!proofs.length) return;
  var EMOJI={heart:['❤️','💖','💕'],deliver:['✅','📮','✨'],leaf:['🍃','🌿','♻️']};
  function go(el){ el.classList.remove('go'); void el.offsetWidth; el.classList.add('go'); }
  function burst(el){
    go(el);
    var num=el.querySelector('.num'); if(num){ num.classList.remove('pop'); void num.offsetWidth; num.classList.add('pop'); }
    var kind=el.getAttribute('data-pkind'), set=EMOJI[kind]||EMOJI.heart;
    var vis=el.querySelector('.proof-vis'), er=el.getBoundingClientRect(), vr=vis.getBoundingClientRect();
    var cx=vr.left+vr.width/2-er.left, cy=vr.top+vr.height/2-er.top;
    for(var i=0;i<7;i++){ var s=document.createElement('span'); s.className='pv-bit'; s.textContent=set[i%set.length];
      s.style.left=cx+'px'; s.style.top=cy+'px';
      var ang=-Math.PI/2 + (i-3)*0.42, dist=42+(i%3)*14;
      s.style.setProperty('--dx',(Math.cos(ang)*dist).toFixed(0)+'px');
      s.style.setProperty('--dy',(Math.sin(ang)*dist-14).toFixed(0)+'px');
      s.style.setProperty('--dr',((i-3)*20)+'deg');
      el.appendChild(s); s.addEventListener('animationend',function(){this.remove();}); }
  }
  var io=new IntersectionObserver(function(en){ en.forEach(function(e){ if(e.isIntersecting){ go(e.target); io.unobserve(e.target); } }); },{threshold:.5});
  proofs.forEach(function(el){ io.observe(el); el.addEventListener('click',function(){ burst(el); }); });
})();
/* Sequence timeline: compute accurate dates from today, weekends pushed to Monday */
(function(){
  var list=document.getElementById('seqtlList'); if(!list) return;
  var WD=['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
  var MO=['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sept','Oct','Nov','Dec'];
  list.querySelectorAll('.seqtl-day').forEach(function(el){
    var n=parseInt(el.getAttribute('data-day'),10)||0;
    var d=new Date(); d.setHours(12,0,0,0); d.setDate(d.getDate()+n);
    var g=d.getDay(); if(g===6) d.setDate(d.getDate()+2); else if(g===0) d.setDate(d.getDate()+1);
    el.textContent='Day '+n+' · '+WD[d.getDay()]+' '+d.getDate()+' '+MO[d.getMonth()];
  });
})();
/* Navigator intro chips jump to the relevant tab */
(function(){
  document.querySelectorAll('.na-chips .nc').forEach(function(c){
    function go(){
      var app=document.querySelector('.na-app'); if(!app) return;
      var tab=app.querySelector('.na-tab[data-nt="'+c.getAttribute('data-goto')+'"]');
      if(tab){ tab.click(); app.scrollIntoView({behavior:'smooth',block:'center'}); }
      c.classList.remove('tap'); void c.offsetWidth; c.classList.add('tap');
    }
    c.addEventListener('click',go);
    c.addEventListener('keydown',function(e){ if(e.key==='Enter'||e.key===' '){ e.preventDefault(); go(); } });
  });
})();
/* v130: the Message button on the LinkedIn profile opens a real message window */
(function(){
  function boot(){
    var btn = document.getElementById('liMsg'), box = document.getElementById('liMbox');
    if(!btn || !box) return;
    var thread = document.getElementById('liMthread'), ta = document.getElementById('liMtext'),
        send = document.getElementById('liMsend'), x = document.getElementById('liMx');
    var DRAFT = 'Hi Mark, your piece on cutting waste across UK sites was a good read. Mind if I send something over?';
    var REPLIES = ['Go on then. What did you have in mind?',
                   'Sounds good. Bristol office is best for me.',
                   'Thanks, I will keep an eye out for it.'];
    var typer = null, turn = 0;
    function bubble(text, me){
      var d = document.createElement('div');
      d.className = 'li-bub' + (me ? ' me' : '');
      d.textContent = text;
      thread.appendChild(d);
      thread.scrollTop = thread.scrollHeight;
      return d;
    }
    function type(){
      clearInterval(typer); ta.value = ''; var i = 0;
      typer = setInterval(function(){
        ta.value = DRAFT.slice(0, ++i);
        if(i >= DRAFT.length) clearInterval(typer);
      }, 18);
    }
    function close(){ box.hidden = true; btn.classList.remove('on'); clearInterval(typer); }
    btn.addEventListener('click', function(){
      if(box.hidden){
        box.hidden = false; btn.classList.add('on');
        if(!ta.value.trim()) type();
        try { ta.focus({ preventScroll: true }); } catch(e){}
      } else { close(); }
    });
    x.addEventListener('click', close);
    send.addEventListener('click', function(){
      var v = ta.value.trim(); if(!v) return;
      clearInterval(typer); bubble(v, true); ta.value = ''; send.disabled = true;
      setTimeout(function(){
        var t = document.createElement('div');
        t.className = 'li-bub';
        t.innerHTML = '<span class="li-typing"><i></i><i></i><i></i></span>';
        thread.appendChild(t); thread.scrollTop = thread.scrollHeight;
        setTimeout(function(){
          t.remove();
          bubble(REPLIES[Math.min(turn, REPLIES.length - 1)], false);
          turn++; send.disabled = false;
        }, 1300);
      }, 450);
    });
    ta.addEventListener('keydown', function(e){
      if(e.key === 'Enter' && !e.shiftKey){ e.preventDefault(); send.click(); }
    });
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
